<template>
  <div class="scroll-wrapper">
    <div class="page-container">
    <!-- <div class="title">
      完善个人信息
      <div class="skip" @click="skip()">跳过</div>
    </div> -->
    <!-- <div class="subtitle">建立您的个人健康档案</div> -->
    <van-steps :active="active">
      <van-step></van-step>
      <van-step></van-step>
      <van-step></van-step>
    </van-steps>
   <div v-if="step1">
     <!-- 性别选择 -->
     <div class="gender-selection">
       <div class="gender-item" @click="selectGender(1)" :class="{ 'gender-selected': avatar == 1 }">
         <div class="gender-icon male-icon">
           <img :src="require('@/assets/mine/8ec41e3ab32a6d5fd8b512b00949249c42d0e6af2d589-8nj1zo_fw1200@2x.png')" alt="男" class="gender-avatar-img" />
         </div>
         <div class="gender-text">男</div>
       </div>
       <div class="gender-item" @click="selectGender(2)" :class="{ 'gender-selected': avatar == 2 }">
         <div class="gender-icon female-icon">
           <img :src="require('@/assets/mine/3x.png')" alt="女" class="gender-avatar-img" />
         </div>
         <div class="gender-text">女</div>
       </div>
     </div>

    <!-- 个人信息表单 -->
    <div class="form-container">
      <div class="form-item" @click="timeClick()">
        <div class="form-label">生日选择</div>
        <div v-if="birthday == ''" class="form-value placeholder">请选择<i class="el-icon-arrow-right"></i></div>
        <div v-else class="form-value">{{ birthday }}<i class="el-icon-arrow-right"></i></div>
      </div>
      
      <div class="form-item" @click="showHeightPicker = true">
        <div class="form-label">身高 (cm)</div>
        <div v-if="height == ''" class="form-value placeholder">请选择<i class="el-icon-arrow-right"></i></div>
        <div v-else class="form-value">{{ height }}<i class="el-icon-arrow-right"></i></div>
      </div>
      
      <div class="form-item" @click="showPicker1 = true">
        <div class="form-label">体重 (公斤)</div>
        <div v-if="weight == ''" class="form-value placeholder">请选择<i class="el-icon-arrow-right"></i></div>
        <div v-else class="form-value">{{ weight }}<i class="el-icon-arrow-right"></i></div>
      </div>
      
      <div class="form-item" @click="showWaistPicker = true">
        <div class="form-label">腰围 (cm)</div>
        <div v-if="waist == ''" class="form-value placeholder">请选择<i class="el-icon-arrow-right"></i></div>
        <div v-else class="form-value">{{ waist }}<i class="el-icon-arrow-right"></i></div>
      </div>
      
      <div class="form-item" @click="showEthnicityPicker = true">
        <div class="form-label">民族</div>
        <div v-if="ethnicity == ''" class="form-value placeholder">请选择<i class="el-icon-arrow-right"></i></div>
        <div v-else class="form-value">{{ ethnicity }}<i class="el-icon-arrow-right"></i></div>
      </div>
      
      <div class="form-item" @click="showLocationPicker = true">
        <div class="form-label">常住地</div>
        <div v-if="location == ''" class="form-value placeholder">请选择<i class="el-icon-arrow-right"></i></div>
        <div v-else class="form-value"><span>{{ getLocationDisplayText() }}</span><i class="el-icon-arrow-right"></i></div>
      </div>
      
      <div class="form-item industry-item" @click="showIndustryPicker = true">
        <div class="form-label">所在行业</div>
        <div v-if="industry == ''" class="form-value placeholder">请选择<i class="el-icon-arrow-right"></i></div>
        <div v-else class="form-value"><span>{{ industry }}</span><i class="el-icon-arrow-right"></i></div>
      </div>
    </div>
    <div class="add1" @click="edit(1)">下一步</div>
   </div>
   <div v-if="step2">
    <!-- 主要问题页面 -->
    <div v-if="step2If">
        <!-- 家族疾病史 -->
        <div class="disease-section">
          <div class="disease-title">是否有家族疾病史</div>
          <div class="disease-options">
            <div class="disease-option" @click="selectFamilyDisease(true)" :class="{ 'disease-selected': familyDisease == true }">
              <div class="disease-text">是</div>
              <div class="disease-count" v-if="familyDiseaseCount > 0">{{ familyDiseaseCount }}</div>
            </div>
            <div class="disease-option" @click="selectFamilyDisease(false)" :class="{ 'disease-selected': familyDisease == false }">
              <div class="disease-text">否</div>
            </div>
          </div>
          <!-- 家族疾病选择卡片 -->
          <div v-if="familyDisease" class="disease-card" @click="showDiseaseSelection('family')">
            <div class="card-header">
              <span>家族疾病史</span>
              <div class="header-right" v-if="selectedFamilyDiseases.length > 0">
                <i class="el-icon-edit"></i>
              </div>
            </div>
            <div class="disease-tags">
              <div v-if="selectedFamilyDiseases.length === 0" class="empty-state">
                <span class="empty-text">暂无家族疾病史</span>
                <span class="add-text">点击添加</span>
              </div>
              <div v-else class="tag-rows">
                <div class="tag-row" v-for="(row, index) in familyDiseaseRows" :key="index">
                  <span 
                    v-for="disease in row" 
                    :key="disease.keyId" 
                    class="disease-tag"
                  >
                    {{ disease.tagName }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 个人疾病史 -->
        <div class="disease-section">
          <div class="disease-title">是否有个人疾病史</div>
          <div class="disease-options">
            <div class="disease-option" @click="selectDisease(true)" :class="{ 'disease-selected': disease == true }">
              <div class="disease-text">是</div>
              <div class="disease-count" v-if="personalDiseaseCount > 0">{{ personalDiseaseCount }}</div>
            </div>
            <div class="disease-option" @click="selectDisease(false)" :class="{ 'disease-selected': disease == false }">
              <div class="disease-text">否</div>
            </div>
          </div>
          <!-- 个人疾病选择卡片 -->
          <div v-if="disease" class="disease-card" @click="showDiseaseSelection('personal')">
            <div class="card-header">
              <span>个人疾病史</span>
              <div class="header-right" v-if="selectedPersonalDiseases.length > 0">
                <i class="el-icon-edit"></i>
              </div>
            </div>
            <div class="disease-tags">
              <div v-if="selectedPersonalDiseases.length === 0" class="empty-state">
                <span class="empty-text">暂无个人疾病史</span>
                <span class="add-text">点击添加</span>
              </div>
              <div v-else class="tag-rows">
                <div class="tag-row" v-for="(row, index) in personalDiseaseRows" :key="index">
                  <span 
                    v-for="disease in row" 
                    :key="disease.keyId" 
                    class="disease-tag"
                  >
                    {{ disease.tagName }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 精神类疾病选择 -->
        <div class="mental-health-section">
          <div class="question-title">是否有以下精神类疾病</div>
          <div class="mental-health-options">
            <div 
              v-for="disease in mentalHealthDiseaseList" 
              :key="disease.id"
              class="mental-health-option" 
              @click="selectMentalHealthCondition(disease.tagName)" 
              :class="{ 'mental-health-selected': mentalHealthConditions.includes(disease.tagName) }"
            >
              <div class="mental-health-text">{{ disease.tagName }}</div>
            </div>
          </div>
        </div>

        <!-- 药物相关问题 -->
        <div class="medication-section" v-if="showAntihypertensiveQuestion || showAntipsychoticQuestion">
          <!-- 降压药物问题 -->
          <div class="medication-item" v-if="showAntihypertensiveQuestion">
            <div class="medication-question">是否服用降压药物</div>
            <div class="medication-select" @click="showAntihypertensivePicker = true">
              <span v-if="antihypertensive === ''" class="placeholder">请选择</span>
              <span v-else>{{ antihypertensive }}</span>
            </div>
          </div>
          
          <!-- 非典型抗精神病药物问题 -->
          <div class="medication-item" v-if="showAntipsychoticQuestion">
            <div class="medication-question">是否服用非典型抗精神病药物</div>
            <div class="medication-select" @click="showAntipsychoticPicker = true">
              <span v-if="antipsychotic === ''" class="placeholder">请选择</span>
              <span v-else>{{ antipsychotic }}</span>
            </div>
          </div>
          
          <!-- 常规类固醇片剂问题 -->
          <div class="medication-item" v-if="showAntipsychoticQuestion">
            <div class="medication-question">
              是否服用常规类固醇片剂
              <!-- <span class="help-icon">?</span> -->
            </div>
            <div class="medication-select" @click="showSteroidPicker = true">
              <span v-if="steroid === ''" class="placeholder">请选择</span>
              <span v-else>{{ steroid }}</span>
            </div>
          </div>
          
          <!-- 勃起功能障碍问题 -->
          <div class="medication-item" v-if="showAntipsychoticQuestion && avatar === 1">
            <div class="medication-question">是否患有勃起功能障碍的诊断或在进行治疗?</div>
            <div class="medication-select" @click="showErectileDysfunctionPicker = true">
              <span v-if="erectileDysfunction === ''" class="placeholder">请选择</span>
              <span v-else>{{ erectileDysfunction }}</span>
            </div>
          </div>
        </div>

        <!-- 抑郁自评 -->
        <div class="depression-section">
          <div class="depression-title">
            抑郁自评自估
            <!-- <span class="depression-count">1</span> -->
          </div>
          <div class="depression-options">
            <div class="depression-option" @click="selectDepression('1')" :class="{ 'depression-selected': depressionLevel == '1' }">
              <div class="depression-text">没有抑郁</div>
            </div>
            <div class="depression-option" @click="selectDepression('2')" :class="{ 'depression-selected': depressionLevel == '2' }">
              <div class="depression-text">有点抑郁</div>
            </div>
            <div class="depression-option" @click="selectDepression('3')" :class="{ 'depression-selected': depressionLevel == '3' }">
              <div class="depression-text">很抑郁</div>
            </div>
          </div>
        </div>

        <div class="add1" @click="edit(2)">下一步</div>
    </div>
    
    <!-- 家族疾病选择页面 -->
    
    <!-- 原有的个人疾病选择页面（保留兼容性） -->
    <div v-else>
        <div class="sdiseaseDiv" @click="selectDisease(true)" :class="{ avatarCla: disease == true}">是</div>
        <div style="margin-top: 20px;text-align: center;">
          <div class="diseaseTab" v-for="(item,index) in diseaseList" :key="index" :class="{ diseaseTabAct: item.selected == true}" @click="selectedClick(index)">{{item.tagName}}</div>
        </div>
        <div class="add1" @click="edit(21)">下一步</div>
    </div>
   </div>
   <div v-if="step3">

        <!-- 睡眠质量时长选择 -->
        <div class="sleep-section">
          <div class="question-title">个人觉得睡眠质量如何？</div>
          <div class="sleep-options">
            <div class="sleep-option" @click="selectSleepDuration('1')" :class="{ 'sleep-selected': sleepDuration === '1' }">
              <div class="sleep-text">9小时以上</div>
            </div>
            <div class="sleep-option" @click="selectSleepDuration('2')" :class="{ 'sleep-selected': sleepDuration === '2' }">
              <div class="sleep-text">7-9小时</div>
            </div>
            <div class="sleep-option" @click="selectSleepDuration('3')" :class="{ 'sleep-selected': sleepDuration === '3' }">
              <div class="sleep-text">5-7小时</div>
            </div>
            <div class="sleep-option" @click="selectSleepDuration('4')" :class="{ 'sleep-selected': sleepDuration === '4' }">
              <div class="sleep-text">小于5小时</div>
            </div>
          </div>
        </div>

        <!-- 吸烟状态选择 -->
        <div class="smoking-section">
          <div class="question-title">是否吸烟</div>
          <div class="smoking-options">
            <div class="smoking-option" @click="selectSmokingStatus('1')" :class="{ 'smoking-selected': smokingStatus === '1' }">
              <div class="smoking-text">不吸烟</div>
            </div>
            <div class="smoking-option" @click="selectSmokingStatus('2')" :class="{ 'smoking-selected': smokingStatus === '2' }">
              <div class="smoking-text">戒烟</div>
            </div>
            <div class="smoking-option" @click="selectSmokingStatus('3')" :class="{ 'smoking-selected': smokingStatus === '3' }">
              <div class="smoking-text">轻度吸烟者（每日少于10支）</div>
          </div>
            <div class="smoking-option" @click="selectSmokingStatus('4')" :class="{ 'smoking-selected': smokingStatus === '4' }">
              <div class="smoking-text">中度吸烟者（每日10至19支）</div>
            </div>
            <div class="smoking-option" @click="selectSmokingStatus('5')" :class="{ 'smoking-selected': smokingStatus === '5' }">
              <div class="smoking-text">重度吸烟者（每日20支及以上）</div>
            </div>
          </div>
        </div>

        <div class="add1" @click="edit(3)">确定</div>
   </div>
   <!-- 
     老年版模式选择对话框（已注释，当前直接跳转）
     功能：让用户在完成信息收集后选择使用普通版还是老年版
     选项：
     - 普通版 (modeAct=0): 标准界面，功能完整
     - 老人版 (modeAct=1): 简化界面，字体更大，操作更简单
     说明：当前版本已改为直接调用modeOnConfirm()方法，不再显示选择对话框
   -->
   <!-- <van-dialog v-model="modeShow" title="请选择使用模式" @confirm="modeOnConfirm" show-cancel-button :lazy-render="false">
    <div class="modeDiv">
      <div style="text-align: center;">
          <div  class="diseaseTab"  @click="modeAct=0" :class="{ step3DivAct: modeAct == 0}" >
           <div>普通版</div>
          </div>
        </div>
        <div style="margin-top: 20px;text-align: center;" >
          <div  class="diseaseTab" @click="modeAct=1" :class="{ step3DivAct: modeAct == 1}">
           <div>老人版</div>
          </div>
        </div>
    </div>
        
    </van-dialog> -->
    <picke
      @child-method="parentMethod"
      @child-show="childShow"
      :value="value"
    ></picke>
    <!-- 体重选择器 -->
    <van-popup v-model:show="showPicker1" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="idTypecolumn1"
          @confirm="onConfirm1"
          @cancel="cancel1"
        />
      </van-popup>
      
      <!-- 身高选择器 -->
      <van-popup v-model:show="showHeightPicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="heightColumns"
          @confirm="onConfirmHeight"
          @cancel="cancelHeight"
        />
      </van-popup>
      
      <!-- 腰围选择器 -->
      <van-popup v-model:show="showWaistPicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="waistColumns"
          @confirm="onConfirmWaist"
          @cancel="cancelWaist"
        />
      </van-popup>
      
      <!-- 民族选择器 -->
      <van-popup v-model:show="showEthnicityPicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="ethnicityColumns"
          @confirm="onConfirmEthnicity"
          @cancel="cancelEthnicity"
        />
      </van-popup>
      
      
      <!-- 常住地选择器 -->
      <van-popup v-model:show="showLocationPicker" round position="bottom" @closed="ensureScrollable">
        <van-cascader
          :model-value="locationCascaderValue"
          title="选择常住地"
          :options="locationColumns"
          @close="cancelLocation"
          @finish="onConfirmLocation"
          @update:model-value="locationCascaderValue = $event"
        />
      </van-popup>
      
      <!-- 行业选择器 -->
      <van-popup v-model:show="showIndustryPicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="industryColumns"
          @confirm="onConfirmIndustry"
          @cancel="cancelIndustry"
        />
      </van-popup>
      
      <!-- 降压药物选择器 -->
      <van-popup v-model:show="showAntihypertensivePicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="yesNoColumns"
          @confirm="onConfirmAntihypertensive"
          @cancel="cancelAntihypertensive"
        />
      </van-popup>
      
      <!-- 抗精神病类药物选择器 -->
      <van-popup v-model:show="showAntipsychoticPicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="yesNoColumns"
          @confirm="onConfirmAntipsychotic"
          @cancel="cancelAntipsychotic"
        />
      </van-popup>
      
      <!-- 类固醇片剂选择器 -->
      <van-popup v-model:show="showSteroidPicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="yesNoColumns"
          @confirm="onConfirmSteroid"
          @cancel="cancelSteroid"
        />
      </van-popup>
      
      <!-- 勃起功能障碍选择器 -->
      <van-popup v-model:show="showErectileDysfunctionPicker" round position="bottom" @closed="ensureScrollable">
        <van-picker
          show-toolbar
          :columns="yesNoColumns"
          @confirm="onConfirmErectileDysfunction"
          @cancel="cancelErectileDysfunction"
        />
      </van-popup>
      <van-dialog v-model="prompt" title="健康档案说明"  @show-cancel-button="false">
        <div class="promptName">为了更加准确的判断您的身体健康情况，请完善个人信息~</div>
        <div class="promptName prompt">（友情提示：请填写监测手表使用者的信息）</div>
      </van-dialog>
      
      <!-- 疾病选择弹框 -->
      <div v-if="showDiseaseModal" class="disease-modal-overlay" @click="closeDiseaseModal">
        <div class="disease-modal" @click.stop>
          <div class="modal-header">
            <div class="modal-title">{{ currentDiseaseType === 'family' ? '选择家族疾病史' : '选择个人疾病史' }}</div>
            <div class="modal-close" @click="closeDiseaseModal">
              <i class="el-icon-close"></i>
            </div>
          </div>
          
          <div class="modal-content">
            <div class="disease-grid">
              <div 
                v-for="disease in currentDiseaseList" 
                :key="disease.keyId"
                class="disease-item"
                :class="{ 
                  'disease-selected': currentDiseaseType === 'family' ? disease.familySelected : disease.selected 
                }"
                @click="toggleDisease(disease)"
              >
                {{ disease.tagName }}
              </div>
            </div>
          </div>
          
          <div class="modal-footer">
            <button class="cancel-btn" @click="closeDiseaseModal">取消</button>
            <button class="confirm-btn" @click="confirmDiseaseSelection">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { medicaltag,v2uphealthinfo,getMedicalTag, health } from '@/api/activity'
import { Dialog } from 'vant-green';
export default {
  data() {
    return {
      birthYear:'',
      brithMoth:'',
      confirm:'',
      height:'',
      idNo:'',
      medHis:'',
      name:'',
      sex:'',
      sleepStatus:'',
      tagParamList:[],	//[TagParam{tagCode	stringtagId	integer($int64)tagName	string}]
      takeMed:'',
      updateBaseHealthInfo:'',
      userCode:'',
      weight:'',
      diseaseList:[],
      // modeAct:0, // 老年版模式选择（已注释，暂时禁用）
      // modeShow:false, // 模式选择对话框显示状态（已注释，暂时禁用）
      prompt: false, // 默认不显示，根据情况动态设置
      quality:0,
      drug:false, // 默认不服用药物
      step2If:true,
      disease:false,
      step1:true,
      step2:false,
      step3:false,
      active:0,
      avatar:1,
      value:false,
      birthday:'',
      height:'',
      waist:'',
      ethnicity:'',
      location:'',
      industry:'',
      showPicker1:false,
      showHeightPicker:false,
      showWaistPicker:false,
      showEthnicityPicker:false,
      showLocationPicker:false,
      locationCascaderValue: [], // 级联选择器的值
      showIndustryPicker:false,
      showAntihypertensivePicker:false,
      showAntipsychoticPicker:false,
      showSteroidPicker:false,
      // 新增字段
      familyDisease:false,
      familyDiseaseCount:0,
      familyDiseaseList:[], // 家族疾病列表
      personalDiseaseCount:0, // 个人疾病数量
      antihypertensive:'',
      antipsychotic:'',
      steroid:'',
      depressionLevel:'',
      // 睡眠质量和吸烟相关字段
      sleepDuration: '', // 睡眠时长
      smokingStatus: '', // 吸烟状态
      // 精神类疾病相关字段
      mentalHealthConditions: ['以上均没有'], // 精神类疾病列表，默认选择"以上均没有"
      mentalHealthDiseaseList: [], // 从接口获取的精神类疾病列表
      erectileDysfunction: '', // 勃起功能障碍
      showErectileDysfunctionPicker: false,
      // 标记是否从接口获取了健康信息
      hasHealthInfoFromApi: false,
      // 疾病选择弹框相关
      showDiseaseModal: false,
      currentDiseaseType: '', // 'family' 或 'personal'
      tempFamilyDiseaseList: [],
      tempDiseaseList: [],
      // 体重选择器数据（35-150公斤）
      idTypecolumn1: (() => {
        const columns = [];
        for (let i = 35; i <= 150; i++) {
          columns.push({ text: `${i}公斤`, keyId: `${i}` });
        }
        return columns;
      })(),
      // 身高选择器数据（140-200厘米）
      heightColumns: (() => {
        const columns = [];
        for (let i = 140; i <= 200; i++) {
          columns.push({ text: `${i}cm`, keyId: `${i}` });
        }
        return columns;
      })(),
      // 腰围选择器数据（50-140厘米）
      waistColumns: (() => {
        const columns = [];
        for (let i = 50; i <= 140; i++) {
          columns.push({ text: `${i}cm`, keyId: `${i}` });
        }
        return columns;
      })(),
      // 民族选择器数据
      ethnicityColumns: [
        { text: "汉族", keyId: "汉族" },
        { text: "蒙古族", keyId: "蒙古族" },
        { text: "回族", keyId: "回族" },
        { text: "藏族", keyId: "藏族" },
        { text: "维吾尔族", keyId: "维吾尔族" },
        { text: "苗族", keyId: "苗族" },
        { text: "彝族", keyId: "彝族" },
        { text: "壮族", keyId: "壮族" },
        { text: "布依族", keyId: "布依族" },
        { text: "朝鲜族", keyId: "朝鲜族" },
        { text: "满族", keyId: "满族" },
        { text: "侗族", keyId: "侗族" },
        { text: "瑶族", keyId: "瑶族" },
        { text: "白族", keyId: "白族" },
        { text: "土家族", keyId: "土家族" },
        { text: "哈尼族", keyId: "哈尼族" },
        { text: "哈萨克族", keyId: "哈萨克族" },
        { text: "傣族", keyId: "傣族" },
        { text: "黎族", keyId: "黎族" },
        { text: "傈僳族", keyId: "傈僳族" },
        { text: "佤族", keyId: "佤族" },
        { text: "畲族", keyId: "畲族" },
        { text: "高山族", keyId: "高山族" },
        { text: "拉祜族", keyId: "拉祜族" },
        { text: "水族", keyId: "水族" },
        { text: "东乡族", keyId: "东乡族" },
        { text: "纳西族", keyId: "纳西族" },
        { text: "景颇族", keyId: "景颇族" },
        { text: "柯尔克孜族", keyId: "柯尔克孜族" },
        { text: "土族", keyId: "土族" },
        { text: "达斡尔族", keyId: "达斡尔族" },
        { text: "仫佬族", keyId: "仫佬族" },
        { text: "羌族", keyId: "羌族" },
        { text: "布朗族", keyId: "布朗族" },
        { text: "撒拉族", keyId: "撒拉族" },
        { text: "毛南族", keyId: "毛南族" },
        { text: "仡佬族", keyId: "仡佬族" },
        { text: "锡伯族", keyId: "锡伯族" },
        { text: "阿昌族", keyId: "阿昌族" },
        { text: "普米族", keyId: "普米族" },
        { text: "塔吉克族", keyId: "塔吉克族" },
        { text: "怒族", keyId: "怒族" },
        { text: "乌孜别克族", keyId: "乌孜别克族" },
        { text: "俄罗斯族", keyId: "俄罗斯族" },
        { text: "鄂温克族", keyId: "鄂温克族" },
        { text: "德昂族", keyId: "德昂族" },
        { text: "保安族", keyId: "保安族" },
        { text: "裕固族", keyId: "裕固族" },
        { text: "京族", keyId: "京族" },
        { text: "塔塔尔族", keyId: "塔塔尔族" },
        { text: "独龙族", keyId: "独龙族" },
        { text: "鄂伦春族", keyId: "鄂伦春族" },
        { text: "赫哲族", keyId: "赫哲族" },
        { text: "门巴族", keyId: "门巴族" },
        { text: "珞巴族", keyId: "珞巴族" },
        { text: "基诺族", keyId: "基诺族" },
        { text: "其他", keyId: "其他" },
       ],
      // 常住地选择器数据（省市二级结构）
       locationColumns: [
         {
           text: "北京市",
           value: "beijing",
           children: [
             { text: "北京市", value: "beijing_city", keyId: "北京市" }
           ]
         },
         {
           text: "上海市", 
           value: "shanghai",
           children: [
             { text: "上海市", value: "shanghai_city", keyId: "上海市" }
           ]
         },
         {
           text: "天津市",
           value: "tianjin",
           children: [
             { text: "天津市", value: "tianjin_city", keyId: "天津市" }
           ]
         },
         {
           text: "重庆市",
           value: "chongqing",
           children: [
             { text: "重庆市", value: "chongqing_city", keyId: "重庆市" }
           ]
         },
         {
           text: "河北省",
           value: "hebei",
           children: [
             { text: "石家庄市", value: "shijiazhuang", keyId: "河北省石家庄市" },
             { text: "唐山市", value: "tangshan", keyId: "河北省唐山市" },
             { text: "秦皇岛市", value: "qinhuangdao", keyId: "河北省秦皇岛市" },
             { text: "邯郸市", value: "handan", keyId: "河北省邯郸市" },
             { text: "邢台市", value: "xingtai", keyId: "河北省邢台市" },
             { text: "保定市", value: "baoding", keyId: "河北省保定市" },
             { text: "张家口市", value: "zhangjiakou", keyId: "河北省张家口市" },
             { text: "承德市", value: "chengde", keyId: "河北省承德市" },
             { text: "沧州市", value: "cangzhou", keyId: "河北省沧州市" },
             { text: "廊坊市", value: "langfang", keyId: "河北省廊坊市" },
             { text: "衡水市", value: "hengshui", keyId: "河北省衡水市" }
           ]
         },
         {
           text: "山西省",
           value: "山西省",
           children: [
             { text: "太原市", value: "太原市", keyId: "山西省太原市" },
             { text: "大同市", value: "大同市", keyId: "山西省大同市" },
             { text: "阳泉市", value: "阳泉市", keyId: "山西省阳泉市" },
             { text: "长治市", value: "长治市", keyId: "山西省长治市" },
             { text: "晋城市", value: "晋城市", keyId: "山西省晋城市" },
             { text: "朔州市", value: "朔州市", keyId: "山西省朔州市" },
             { text: "晋中市", value: "晋中市", keyId: "山西省晋中市" },
             { text: "运城市", value: "运城市", keyId: "山西省运城市" },
             { text: "忻州市", value: "忻州市", keyId: "山西省忻州市" },
             { text: "临汾市", value: "临汾市", keyId: "山西省临汾市" },
             { text: "吕梁市", value: "吕梁市", keyId: "山西省吕梁市" }
           ]
         },
         {
           text: "内蒙古自治区",
           value: "neimenggu",
           children: [
             { text: "呼和浩特市", value: "hohhot", keyId: "内蒙古自治区呼和浩特市" },
             { text: "包头市", value: "baotou", keyId: "内蒙古自治区包头市" },
             { text: "乌海市", value: "wuhai", keyId: "内蒙古自治区乌海市" },
             { text: "赤峰市", value: "chifeng", keyId: "内蒙古自治区赤峰市" },
             { text: "通辽市", value: "tongliao", keyId: "内蒙古自治区通辽市" },
            { text: "鄂尔多斯市", value: "eerduosi", keyId: "内蒙古自治区鄂尔多斯市" },
            { text: "呼伦贝尔市", value: "hulunbeier", keyId: "内蒙古自治区呼伦贝尔市" },
            { text: "巴彦淖尔市", value: "bayannaoer", keyId: "内蒙古自治区巴彦淖尔市" },
            { text: "乌兰察布市", value: "wulanchabu", keyId: "内蒙古自治区乌兰察布市" }
           ]
         },
        {
          text: "辽宁省",
          value: "liaoning",
          children: [
            { text: "沈阳市", value: "shenyang", keyId: "辽宁省沈阳市" },
            { text: "大连市", value: "dalian", keyId: "辽宁省大连市" },
            { text: "鞍山市", value: "anshan", keyId: "辽宁省鞍山市" },
            { text: "抚顺市", value: "fushun", keyId: "辽宁省抚顺市" },
            { text: "本溪市", value: "benxi", keyId: "辽宁省本溪市" },
            { text: "丹东市", value: "dandong", keyId: "辽宁省丹东市" },
            { text: "锦州市", value: "jinzhou", keyId: "辽宁省锦州市" },
            { text: "营口市", value: "yingkou", keyId: "辽宁省营口市" },
            { text: "阜新市", value: "fuxin", keyId: "辽宁省阜新市" },
            { text: "辽阳市", value: "liaoyang", keyId: "辽宁省辽阳市" },
            { text: "盘锦市", value: "panjin", keyId: "辽宁省盘锦市" },
            { text: "铁岭市", value: "tieling", keyId: "辽宁省铁岭市" },
            { text: "朝阳市", value: "chaoyang", keyId: "辽宁省朝阳市" },
            { text: "葫芦岛市", value: "huludao", keyId: "辽宁省葫芦岛市" }
          ]
        },
        {
          text: "吉林省",
          value: "jilin",
          children: [
            { text: "长春市", value: "changchun", keyId: "吉林省长春市" },
            { text: "吉林市", value: "jilin_city", keyId: "吉林省吉林市" },
            { text: "四平市", value: "siping", keyId: "吉林省四平市" },
            { text: "辽源市", value: "liaoyuan", keyId: "吉林省辽源市" },
            { text: "通化市", value: "tonghua", keyId: "吉林省通化市" },
            { text: "白山市", value: "baishan", keyId: "吉林省白山市" },
            { text: "松原市", value: "songyuan", keyId: "吉林省松原市" },
            { text: "白城市", value: "baicheng", keyId: "吉林省白城市" }
          ]
        },
        {
          text: "黑龙江省",
          value: "heilongjiang",
          children: [
            { text: "哈尔滨市", value: "harbin", keyId: "黑龙江省哈尔滨市" },
            { text: "齐齐哈尔市", value: "qiqihar", keyId: "黑龙江省齐齐哈尔市" },
            { text: "鸡西市", value: "jixi", keyId: "黑龙江省鸡西市" },
            { text: "鹤岗市", value: "hegang", keyId: "黑龙江省鹤岗市" },
            { text: "双鸭山市", value: "shuangyashan", keyId: "黑龙江省双鸭山市" },
            { text: "大庆市", value: "daqing", keyId: "黑龙江省大庆市" },
            { text: "伊春市", value: "yichun", keyId: "黑龙江省伊春市" },
            { text: "佳木斯市", value: "jiamusi", keyId: "黑龙江省佳木斯市" },
            { text: "七台河市", value: "qitaihe", keyId: "黑龙江省七台河市" },
            { text: "牡丹江市", value: "mudanjiang", keyId: "黑龙江省牡丹江市" },
            { text: "黑河市", value: "heihe", keyId: "黑龙江省黑河市" },
            { text: "绥化市", value: "suihua", keyId: "黑龙江省绥化市" }
          ]
        },
        {
          text: "江苏省",
          value: "jiangsu",
          children: [
            { text: "南京市", value: "nanjing", keyId: "江苏省南京市" },
            { text: "无锡市", value: "wuxi", keyId: "江苏省无锡市" },
            { text: "徐州市", value: "xuzhou", keyId: "江苏省徐州市" },
            { text: "常州市", value: "changzhou", keyId: "江苏省常州市" },
            { text: "苏州市", value: "suzhou", keyId: "江苏省苏州市" },
            { text: "南通市", value: "nantong", keyId: "江苏省南通市" },
            { text: "连云港市", value: "lianyungang", keyId: "江苏省连云港市" },
            { text: "淮安市", value: "huaian", keyId: "江苏省淮安市" },
            { text: "盐城市", value: "yancheng", keyId: "江苏省盐城市" },
            { text: "扬州市", value: "yangzhou", keyId: "江苏省扬州市" },
            { text: "镇江市", value: "zhenjiang", keyId: "江苏省镇江市" },
            { text: "泰州市", value: "taizhou", keyId: "江苏省泰州市" },
            { text: "宿迁市", value: "suqian", keyId: "江苏省宿迁市" }
          ]
        },
        {
          text: "浙江省",
          value: "zhejiang",
          children: [
            { text: "杭州市", value: "hangzhou", keyId: "浙江省杭州市" },
            { text: "宁波市", value: "ningbo", keyId: "浙江省宁波市" },
            { text: "温州市", value: "wenzhou", keyId: "浙江省温州市" },
            { text: "嘉兴市", value: "jiaxing", keyId: "浙江省嘉兴市" },
            { text: "湖州市", value: "huzhou", keyId: "浙江省湖州市" },
            { text: "绍兴市", value: "shaoxing", keyId: "浙江省绍兴市" },
            { text: "金华市", value: "jinhua", keyId: "浙江省金华市" },
            { text: "衢州市", value: "quzhou", keyId: "浙江省衢州市" },
            { text: "舟山市", value: "zhoushan", keyId: "浙江省舟山市" },
            { text: "台州市", value: "taizhou_zj", keyId: "浙江省台州市" },
            { text: "丽水市", value: "lishui", keyId: "浙江省丽水市" }
          ]
        },
        {
          text: "安徽省",
          value: "anhui",
          children: [
            { text: "合肥市", value: "hefei", keyId: "安徽省合肥市" },
            { text: "芜湖市", value: "wuhu", keyId: "安徽省芜湖市" },
            { text: "蚌埠市", value: "bengbu", keyId: "安徽省蚌埠市" },
            { text: "淮南市", value: "huainan", keyId: "安徽省淮南市" },
            { text: "马鞍山市", value: "maanshan", keyId: "安徽省马鞍山市" },
            { text: "淮北市", value: "huaibei", keyId: "安徽省淮北市" },
            { text: "铜陵市", value: "tongling", keyId: "安徽省铜陵市" },
            { text: "安庆市", value: "anqing", keyId: "安徽省安庆市" },
            { text: "黄山市", value: "huangshan", keyId: "安徽省黄山市" },
            { text: "滁州市", value: "chuzhou", keyId: "安徽省滁州市" },
            { text: "阜阳市", value: "fuyang", keyId: "安徽省阜阳市" },
            { text: "宿州市", value: "suzhou_ah", keyId: "安徽省宿州市" },
            { text: "六安市", value: "liuan", keyId: "安徽省六安市" },
            { text: "亳州市", value: "bozhou", keyId: "安徽省亳州市" },
            { text: "池州市", value: "chizhou", keyId: "安徽省池州市" },
            { text: "宣城市", value: "xuancheng", keyId: "安徽省宣城市" }
          ]
        },
         {
           text: "福建省",
           children: [
             { text: "福州市", keyId: "福建省福州市" },
             { text: "厦门市", keyId: "福建省厦门市" },
             { text: "莆田市", keyId: "福建省莆田市" },
             { text: "三明市", keyId: "福建省三明市" },
             { text: "泉州市", keyId: "福建省泉州市" },
             { text: "漳州市", keyId: "福建省漳州市" },
             { text: "南平市", keyId: "福建省南平市" },
             { text: "龙岩市", keyId: "福建省龙岩市" },
             { text: "宁德市", keyId: "福建省宁德市" }
           ]
         },
         {
           text: "江西省",
           children: [
             { text: "南昌市", keyId: "江西省南昌市" },
             { text: "景德镇市", keyId: "江西省景德镇市" },
             { text: "萍乡市", keyId: "江西省萍乡市" },
             { text: "九江市", keyId: "江西省九江市" },
             { text: "新余市", keyId: "江西省新余市" },
             { text: "鹰潭市", keyId: "江西省鹰潭市" },
             { text: "赣州市", keyId: "江西省赣州市" },
             { text: "吉安市", keyId: "江西省吉安市" },
             { text: "宜春市", keyId: "江西省宜春市" },
             { text: "抚州市", keyId: "江西省抚州市" },
             { text: "上饶市", keyId: "江西省上饶市" }
           ]
         },
         {
           text: "山东省",
           children: [
             { text: "济南市", keyId: "山东省济南市" },
             { text: "青岛市", keyId: "山东省青岛市" },
             { text: "淄博市", keyId: "山东省淄博市" },
             { text: "枣庄市", keyId: "山东省枣庄市" },
             { text: "东营市", keyId: "山东省东营市" },
             { text: "烟台市", keyId: "山东省烟台市" },
             { text: "潍坊市", keyId: "山东省潍坊市" },
             { text: "济宁市", keyId: "山东省济宁市" },
             { text: "泰安市", keyId: "山东省泰安市" },
             { text: "威海市", keyId: "山东省威海市" },
             { text: "日照市", keyId: "山东省日照市" },
             { text: "临沂市", keyId: "山东省临沂市" },
             { text: "德州市", keyId: "山东省德州市" },
             { text: "聊城市", keyId: "山东省聊城市" },
             { text: "滨州市", keyId: "山东省滨州市" },
             { text: "菏泽市", keyId: "山东省菏泽市" }
           ]
         },
         {
           text: "河南省",
           children: [
             { text: "郑州市", keyId: "河南省郑州市" },
             { text: "开封市", keyId: "河南省开封市" },
             { text: "洛阳市", keyId: "河南省洛阳市" },
             { text: "平顶山市", keyId: "河南省平顶山市" },
             { text: "安阳市", keyId: "河南省安阳市" },
             { text: "鹤壁市", keyId: "河南省鹤壁市" },
             { text: "新乡市", keyId: "河南省新乡市" },
             { text: "焦作市", keyId: "河南省焦作市" },
             { text: "濮阳市", keyId: "河南省濮阳市" },
             { text: "许昌市", keyId: "河南省许昌市" },
             { text: "漯河市", keyId: "河南省漯河市" },
             { text: "三门峡市", keyId: "河南省三门峡市" },
             { text: "南阳市", keyId: "河南省南阳市" },
             { text: "商丘市", keyId: "河南省商丘市" },
             { text: "信阳市", keyId: "河南省信阳市" },
             { text: "周口市", keyId: "河南省周口市" },
             { text: "驻马店市", keyId: "河南省驻马店市" },
             { text: "济源市", keyId: "河南省济源市" }
           ]
         },
         {
           text: "湖北省",
           children: [
             { text: "武汉市", keyId: "湖北省武汉市" },
             { text: "黄石市", keyId: "湖北省黄石市" },
             { text: "十堰市", keyId: "湖北省十堰市" },
             { text: "宜昌市", keyId: "湖北省宜昌市" },
             { text: "襄阳市", keyId: "湖北省襄阳市" },
             { text: "鄂州市", keyId: "湖北省鄂州市" },
             { text: "荆门市", keyId: "湖北省荆门市" },
             { text: "孝感市", keyId: "湖北省孝感市" },
             { text: "荆州市", keyId: "湖北省荆州市" },
             { text: "黄冈市", keyId: "湖北省黄冈市" },
             { text: "咸宁市", keyId: "湖北省咸宁市" },
             { text: "随州市", keyId: "湖北省随州市" }
           ]
         },
         {
           text: "湖南省",
           children: [
             { text: "长沙市", keyId: "湖南省长沙市" },
             { text: "株洲市", keyId: "湖南省株洲市" },
             { text: "湘潭市", keyId: "湖南省湘潭市" },
             { text: "衡阳市", keyId: "湖南省衡阳市" },
             { text: "邵阳市", keyId: "湖南省邵阳市" },
             { text: "岳阳市", keyId: "湖南省岳阳市" },
             { text: "常德市", keyId: "湖南省常德市" },
             { text: "张家界市", keyId: "湖南省张家界市" },
             { text: "益阳市", keyId: "湖南省益阳市" },
             { text: "郴州市", keyId: "湖南省郴州市" },
             { text: "永州市", keyId: "湖南省永州市" },
             { text: "怀化市", keyId: "湖南省怀化市" },
             { text: "娄底市", keyId: "湖南省娄底市" }
           ]
         },
         {
           text: "广东省",
           children: [
             { text: "广州市", keyId: "广东省广州市" },
             { text: "深圳市", keyId: "广东省深圳市" },
             { text: "珠海市", keyId: "广东省珠海市" },
             { text: "汕头市", keyId: "广东省汕头市" },
             { text: "佛山市", keyId: "广东省佛山市" },
             { text: "韶关市", keyId: "广东省韶关市" },
             { text: "湛江市", keyId: "广东省湛江市" },
             { text: "肇庆市", keyId: "广东省肇庆市" },
             { text: "江门市", keyId: "广东省江门市" },
             { text: "茂名市", keyId: "广东省茂名市" },
             { text: "惠州市", keyId: "广东省惠州市" },
             { text: "梅州市", keyId: "广东省梅州市" },
             { text: "汕尾市", keyId: "广东省汕尾市" },
             { text: "河源市", keyId: "广东省河源市" },
             { text: "阳江市", keyId: "广东省阳江市" },
             { text: "清远市", keyId: "广东省清远市" },
             { text: "东莞市", keyId: "广东省东莞市" },
             { text: "中山市", keyId: "广东省中山市" },
             { text: "潮州市", keyId: "广东省潮州市" },
             { text: "揭阳市", keyId: "广东省揭阳市" },
             { text: "云浮市", keyId: "广东省云浮市" }
           ]
         },
         {
           text: "广西壮族自治区",
           children: [
             { text: "南宁市", keyId: "广西壮族自治区南宁市" },
             { text: "柳州市", keyId: "广西壮族自治区柳州市" },
             { text: "桂林市", keyId: "广西壮族自治区桂林市" },
             { text: "梧州市", keyId: "广西壮族自治区梧州市" },
             { text: "北海市", keyId: "广西壮族自治区北海市" },
             { text: "防城港市", keyId: "广西壮族自治区防城港市" },
             { text: "钦州市", keyId: "广西壮族自治区钦州市" },
             { text: "贵港市", keyId: "广西壮族自治区贵港市" },
             { text: "玉林市", keyId: "广西壮族自治区玉林市" },
             { text: "百色市", keyId: "广西壮族自治区百色市" },
             { text: "贺州市", keyId: "广西壮族自治区贺州市" },
             { text: "河池市", keyId: "广西壮族自治区河池市" },
             { text: "来宾市", keyId: "广西壮族自治区来宾市" },
             { text: "崇左市", keyId: "广西壮族自治区崇左市" }
           ]
         },
         {
           text: "海南省",
           children: [
             { text: "海口市", keyId: "海南省海口市" },
             { text: "三亚市", keyId: "海南省三亚市" },
             { text: "三沙市", keyId: "海南省三沙市" },
             { text: "儋州市", keyId: "海南省儋州市" }
           ]
         },
         {
           text: "四川省",
           children: [
             { text: "成都市", keyId: "四川省成都市" },
             { text: "自贡市", keyId: "四川省自贡市" },
             { text: "攀枝花市", keyId: "四川省攀枝花市" },
             { text: "泸州市", keyId: "四川省泸州市" },
             { text: "德阳市", keyId: "四川省德阳市" },
             { text: "绵阳市", keyId: "四川省绵阳市" },
             { text: "广元市", keyId: "四川省广元市" },
             { text: "遂宁市", keyId: "四川省遂宁市" },
             { text: "内江市", keyId: "四川省内江市" },
             { text: "乐山市", keyId: "四川省乐山市" },
             { text: "南充市", keyId: "四川省南充市" },
             { text: "眉山市", keyId: "四川省眉山市" },
             { text: "宜宾市", keyId: "四川省宜宾市" },
             { text: "广安市", keyId: "四川省广安市" },
             { text: "达州市", keyId: "四川省达州市" },
             { text: "雅安市", keyId: "四川省雅安市" },
             { text: "巴中市", keyId: "四川省巴中市" },
             { text: "资阳市", keyId: "四川省资阳市" }
           ]
         },
         {
           text: "贵州省",
           children: [
             { text: "贵阳市", keyId: "贵州省贵阳市" },
             { text: "六盘水市", keyId: "贵州省六盘水市" },
             { text: "遵义市", keyId: "贵州省遵义市" },
             { text: "安顺市", keyId: "贵州省安顺市" },
             { text: "毕节市", keyId: "贵州省毕节市" },
             { text: "铜仁市", keyId: "贵州省铜仁市" }
           ]
         },
         {
           text: "云南省",
           children: [
             { text: "昆明市", keyId: "云南省昆明市" },
             { text: "曲靖市", keyId: "云南省曲靖市" },
             { text: "玉溪市", keyId: "云南省玉溪市" },
             { text: "保山市", keyId: "云南省保山市" },
             { text: "昭通市", keyId: "云南省昭通市" },
             { text: "丽江市", keyId: "云南省丽江市" },
             { text: "普洱市", keyId: "云南省普洱市" },
             { text: "临沧市", keyId: "云南省临沧市" }
           ]
         },
         {
           text: "西藏自治区",
           children: [
             { text: "拉萨市", keyId: "西藏自治区拉萨市" },
             { text: "日喀则市", keyId: "西藏自治区日喀则市" },
             { text: "昌都市", keyId: "西藏自治区昌都市" },
             { text: "林芝市", keyId: "西藏自治区林芝市" },
             { text: "山南市", keyId: "西藏自治区山南市" },
             { text: "那曲市", keyId: "西藏自治区那曲市" },
             { text: "阿里地区", keyId: "西藏自治区阿里地区" }
           ]
         },
         {
           text: "陕西省",
           children: [
             { text: "西安市", keyId: "陕西省西安市" },
             { text: "铜川市", keyId: "陕西省铜川市" },
             { text: "宝鸡市", keyId: "陕西省宝鸡市" },
             { text: "咸阳市", keyId: "陕西省咸阳市" },
             { text: "渭南市", keyId: "陕西省渭南市" },
             { text: "延安市", keyId: "陕西省延安市" },
             { text: "汉中市", keyId: "陕西省汉中市" },
             { text: "榆林市", keyId: "陕西省榆林市" },
             { text: "安康市", keyId: "陕西省安康市" },
             { text: "商洛市", keyId: "陕西省商洛市" }
           ]
         },
         {
           text: "甘肃省",
           children: [
             { text: "兰州市", keyId: "甘肃省兰州市" },
             { text: "嘉峪关市", keyId: "甘肃省嘉峪关市" },
             { text: "金昌市", keyId: "甘肃省金昌市" },
             { text: "白银市", keyId: "甘肃省白银市" },
             { text: "天水市", keyId: "甘肃省天水市" },
             { text: "武威市", keyId: "甘肃省武威市" },
             { text: "张掖市", keyId: "甘肃省张掖市" },
             { text: "平凉市", keyId: "甘肃省平凉市" },
             { text: "酒泉市", keyId: "甘肃省酒泉市" },
             { text: "庆阳市", keyId: "甘肃省庆阳市" },
             { text: "定西市", keyId: "甘肃省定西市" },
             { text: "陇南市", keyId: "甘肃省陇南市" }
           ]
         },
         {
           text: "青海省",
           children: [
             { text: "西宁市", keyId: "青海省西宁市" },
             { text: "海东市", keyId: "青海省海东市" }
           ]
         },
         {
           text: "宁夏回族自治区",
           children: [
             { text: "银川市", keyId: "宁夏回族自治区银川市" },
             { text: "石嘴山市", keyId: "宁夏回族自治区石嘴山市" },
             { text: "吴忠市", keyId: "宁夏回族自治区吴忠市" },
             { text: "固原市", keyId: "宁夏回族自治区固原市" },
             { text: "中卫市", keyId: "宁夏回族自治区中卫市" }
           ]
         },
         {
           text: "新疆维吾尔自治区",
           children: [
             { text: "乌鲁木齐市", keyId: "新疆维吾尔自治区乌鲁木齐市" },
             { text: "克拉玛依市", keyId: "新疆维吾尔自治区克拉玛依市" },
             { text: "吐鲁番市", keyId: "新疆维吾尔自治区吐鲁番市" },
             { text: "哈密市", keyId: "新疆维吾尔自治区哈密市" }
           ]
         },
         {
           text: "香港特别行政区",
           children: [
             { text: "香港特别行政区", keyId: "香港特别行政区" }
           ]
         },
         {
           text: "澳门特别行政区",
           children: [
             { text: "澳门特别行政区", keyId: "澳门特别行政区" }
           ]
         },
         {
           text: "台湾省",
           children: [
             { text: "台湾省", keyId: "台湾省" }
           ]
         }
       ],
       // 行业选择器数据
       industryColumns: [
        { text: "重体力行业（司机、医务工作者等）", keyId: "1" },
        { text: "轻体力（职员）", keyId: "2" },
      ],
      // 是/否选择器数据
      yesNoColumns: [
        { text: "是", keyId: "是" },
        { text: "否", keyId: "否" },
      ],
      obj:{}
    };
  },
   async mounted() {
     document.title = '完善个人信息'
     this.userCode = localStorage.getItem('userCode'); 
     
     // 修复数据结构
     this.fixLocationDataStructure();
     
     // 获取用户健康信息（性别和出生日期）
     await this.getUserHealthInfo();
     
     // 恢复之前保存的数据（如果接口没有数据，则使用临时保存的数据）
     this.restoreUserData();
     
     // 显示健康档案说明
     this.prompt = true;
     
     // 获取疾病数据
     this.loadDiseaseData();
     
     // 确保页面可以正常滚动
     this.ensureScrollable();
   },
   
   /**
    * 组件销毁前清理
    * 确保离开页面时恢复 body 的滚动能力
    */
   beforeUnmount() {
     this.restoreBodyScroll();
   },
  components: {
    picke: () => import("./picke"),
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    /**
     * 是否显示降压药物问题
     * 条件：个人疾病史选择"是" 且 选择了高血压或冠心病
     */
    showAntihypertensiveQuestion() {
      if (!this.disease) return false; // 个人疾病史必须选择"是"
      
      // 检查是否选择了高血压或冠心病
      const antihypertensiveDiseases = ['高血压', '冠心病'];
      return this.diseaseList.some(item => 
        item.selected && antihypertensiveDiseases.includes(item.tagName)
      );
    },

    /**
     * 是否显示抗精神病类药物问题
     * 条件：精神类疾病选择了不是"以上均没有"的选项
     */
    showAntipsychoticQuestion() {
      // 检查精神类疾病选择中是否包含不是"以上均没有"的选项
      return this.mentalHealthConditions.some(condition => condition !== '以上均没有');
    },

    /**
     * 是否显示常规类固醇片剂问题
     * 条件：个人疾病史选择"是" 且 选择了炎症和免疫异常或激素失衡相关疾病
     */
    showSteroidQuestion() {
      if (!this.disease) return false; // 个人疾病史必须选择"是"
      
      // 检查是否选择了炎症和免疫异常或激素失衡相关疾病
      const steroidDiseases = ['系统性红斑狼疮', '类风湿性关节炎'];
      return this.diseaseList.some(item => 
        item.selected && steroidDiseases.includes(item.tagName)
      );
    },

    /**
     * 是否显示勃起功能障碍问题
     * 条件：个人疾病史选择"是" 且 选择了相关疾病，且为男性用户
     */
    showErectileDysfunctionQuestion() {
      if (!this.disease || this.avatar !== 1) return false; // 个人疾病史必须选择"是" 且 为男性用户
      
      // 检查是否选择了相关疾病
      const erectileDiseases = ['糖尿病一型', '糖尿病二型', '高血压', '男科病'];
      return this.diseaseList.some(item => 
        item.selected && erectileDiseases.includes(item.tagName)
      );
    },

    /**
     * 过滤后的疾病列表（根据性别过滤）
     */
    filteredDiseaseList() {
      return this.diseaseList.filter(item => {
        // 女性用户不显示男科病
        if (this.avatar === 2 && item.tagName === '男科病') {
          return false;
        }
        // 男性用户不显示妇科病
        if (this.avatar === 1 && item.tagName === '妇科病') {
          return false;
        }
        return true;
      });
    },
    
    /**
     * 选中的家族疾病
     */
    selectedFamilyDiseases() {
      return this.familyDiseaseList.filter(item => item.familySelected);
    },
    
    /**
     * 选中的个人疾病
     */
    selectedPersonalDiseases() {
      return this.diseaseList.filter(item => item.selected);
    },
    
    /**
     * 家族疾病按行分组显示（每行2个）
     */
    familyDiseaseRows() {
      const diseases = this.selectedFamilyDiseases;
      const rows = [];
      for (let i = 0; i < diseases.length; i += 2) {
        rows.push(diseases.slice(i, i + 2));
      }
      return rows;
    },
    
    /**
     * 个人疾病按行分组显示（每行2个）
     */
    personalDiseaseRows() {
      const diseases = this.selectedPersonalDiseases;
      const rows = [];
      for (let i = 0; i < diseases.length; i += 2) {
        rows.push(diseases.slice(i, i + 2));
      }
      return rows;
    },
    
    /**
     * 当前疾病列表（根据类型返回家族疾病或个人疾病）
     */
    currentDiseaseList() {
      if (this.showDiseaseModal) {
        // 弹窗显示时使用临时数据
        return this.currentDiseaseType === 'family' ? this.tempFamilyDiseaseList : this.tempDiseaseList;
      } else {
        // 非弹窗状态使用正式数据
        return this.currentDiseaseType === 'family' ? this.familyDiseaseList : this.diseaseList;
      }
    }
  },
  methods: {
    /**
     * 获取用户健康信息（性别和出生日期）
     */
    async getUserHealthInfo() {
      try {
        const res = await health();
        if (res.code == 1000 && res.data) {
          // 设置性别：1-男，2-女
          if (res.data.sex !== null && res.data.sex !== undefined) {
            this.avatar = res.data.sex;
          }
          
          // 设置出生日期
          if (res.data.birthday) {
            // 接口返回的日期格式可能是 "YYYY-MM-DD"，直接使用
            this.birthday = res.data.birthday;
          }
          
          console.log('获取用户健康信息成功:', {
            sex: this.avatar,
            birthday: this.birthday
          });
          
          // 标记已从接口获取数据
          this.hasHealthInfoFromApi = true;
        }
      } catch (error) {
        console.error('获取用户健康信息失败:', error);
        this.hasHealthInfoFromApi = false;
      }
    },
    /**
     * 确保页面可以正常滚动
     * 修复 van-popup 等组件可能导致的滚动锁定问题
     */
    ensureScrollable() {
      // 移除可能残留的 overflow: hidden
      const body = document.body;
      const html = document.documentElement;
      
      // 强制恢复滚动
      body.style.overflow = '';
      body.style.position = '';
      body.style.width = '';
      html.style.overflow = '';
      
      // 移除可能存在的滚动锁定类
      body.classList.remove('van-overflow-hidden');
      
      console.log('页面滚动已恢复');
    },
    
    /**
     * 恢复 body 的滚动能力
     * 在组件销毁前调用，确保不影响其他页面
     */
    restoreBodyScroll() {
      const body = document.body;
      const html = document.documentElement;
      
      body.style.overflow = '';
      body.style.position = '';
      body.style.width = '';
      html.style.overflow = '';
      body.classList.remove('van-overflow-hidden');
      
      console.log('组件销毁，body 滚动已恢复');
    },
    
    /**
     * 加载疾病数据
     */
    async loadDiseaseData() {
      try {
        // 并行获取三种类型的疾病数据
        const [personalDiseases, familyDiseases, mentalDiseases] = await Promise.all([
          this.getDiseaseDataByType('1001'), // 普通疾病
          this.getDiseaseDataByType('2001'), // 家族史疾病
          this.getDiseaseDataByType('3001')  // 精神类疾病
        ]);
        
        // 处理个人疾病数据
        this.diseaseList = personalDiseases.map(item => ({
          keyId: item.id,
          tagName: item.tagName,
          selected: false,
          familySelected: false
        }));
        
        // 处理家族疾病数据
        this.familyDiseaseList = familyDiseases.map(item => ({
          keyId: item.id,
          tagName: item.tagName,
          selected: false,
          familySelected: false
        }));
        
        // 处理精神类疾病数据
        this.mentalHealthDiseaseList = mentalDiseases.map(item => ({
          id: item.id,
          tagName: item.tagName,
          selected: false
        }));
        
        console.log('个人疾病列表:', this.diseaseList);
        console.log('家族疾病史列表:', this.familyDiseaseList);
        console.log('精神类疾病列表:', this.mentalHealthDiseaseList);
        
        // 恢复之前保存的疾病选择状态
        this.restoreDiseaseSelections();
        
      } catch (error) {
        console.error('获取疾病数据失败:', error);
        // 如果接口调用失败，清空数据
        this.diseaseList = [];
        this.familyDiseaseList = [];
        this.mentalHealthDiseaseList = [];
      }
    },

    /**
     * 根据类型获取疾病数据
     */
    async getDiseaseDataByType(type) {
      try {
        // 获取当前选择的性别，1-男性，2-女性
        const gender = this.avatar || 1;
        const response = await getMedicalTag({ 
          type,
          gender 
        });
        if (response.code === '1000' && response.data) {
          return response.data;
        } else {
          console.warn(`获取类型${type}的疾病数据失败:`, response.msg);
          return [];
        }
      } catch (error) {
        console.error(`获取类型${type}的疾病数据异常:`, error);
        return [];
      }
    },

    /**
     * 恢复疾病选择状态
     */
    restoreDiseaseSelections() {
      const savedData = localStorage.getItem('informationGathering_backup');
      if (savedData) {
        try {
          const userData = JSON.parse(savedData);
          
          // 恢复个人疾病选择状态
          if (userData.diseaseList && userData.diseaseList.length > 0) {
            this.mergeDiseaseList(userData.diseaseList);
          }
          
          // 恢复家族疾病选择状态
          if (userData.familyDiseaseList && userData.familyDiseaseList.length > 0) {
            this.mergeFamilyDiseaseList(userData.familyDiseaseList);
          }
          
          // 恢复精神类疾病选择状态
          if (userData.mentalHealthConditions && userData.mentalHealthConditions.length > 0) {
            this.mentalHealthConditions = userData.mentalHealthConditions;
          }
          
        } catch (e) {
          console.error('恢复疾病选择状态失败:', e);
        }
      }
    },

    /**
     * 合并个人疾病列表数据
     */
    mergeDiseaseList(savedDiseaseList) {
      if (this.diseaseList && this.diseaseList.length > 0) {
        savedDiseaseList.forEach(savedItem => {
          const currentItem = this.diseaseList.find(item => item.keyId === savedItem.keyId);
          if (currentItem) {
            currentItem.selected = savedItem.selected;
            if (savedItem.familySelected !== undefined) {
              currentItem.familySelected = savedItem.familySelected;
            }
          }
        });
        this.updatePersonalDiseaseCount();
      }
    },

    /**
     * 合并家族疾病列表数据
     */
    mergeFamilyDiseaseList(savedFamilyDiseaseList) {
      if (this.familyDiseaseList && this.familyDiseaseList.length > 0) {
        savedFamilyDiseaseList.forEach(savedItem => {
          const currentItem = this.familyDiseaseList.find(item => item.keyId === savedItem.keyId);
          if (currentItem) {
            currentItem.familySelected = savedItem.familySelected;
          }
        });
        this.updateFamilyDiseaseCount();
      }
    },

    /**
     * 调用v2接口保存健康信息
     * @param {number} step - 当前步骤：1-基础信息，2-疾病信息，3-生活习惯
     */
    v2uphealthinfoFun(step = 1) {   
      // 构建基础请求参数
      const requestData = {
        userCode: this.userCode
      };

      // 根据步骤添加对应的数据
      if (step === 1) {
        // 第一步：基础身体信息
        if (this.height) requestData.height = parseInt(this.height);
        if (this.weight) requestData.weight = parseInt(this.weight);
        if (this.birthday) requestData.birthday = this.birthday;
        if (this.avatar) requestData.sex = this.avatar;
        if (this.waist) requestData.waistline = parseInt(this.waist);
        if (this.ethnicity) requestData.ethnicity = this.ethnicity;
        if (this.location) requestData.residence = this.location;
        if (this.industry) {
          // 将显示的文本转换为对应的keyId
          const industryItem = this.industryColumns.find(item => item.text === this.industry);
          requestData.industry = industryItem ? industryItem.keyId : this.industry;
        }
      } else if (step === 2) {
        // 第二步：疾病相关信息
        if (this.disease !== undefined) requestData.medHis = this.disease;
        if (this.disease && this.getSelectedDiseases().length > 0) {
          requestData.tagParamList = this.getSelectedDiseases();
        }
        if (this.familyDisease !== undefined) requestData.familyMedHis = this.familyDisease;
        if (this.familyDisease && this.getSelectedFamilyDiseases().length > 0) {
          requestData.familyMedList = this.getSelectedFamilyDiseases();
        }
        if (this.getSelectedMentalDiseases().length > 0) {
          requestData.mentalMedList = this.getSelectedMentalDiseases();
        }
        if (this.antihypertensive) {
          requestData.hypertensionTreatment = this.antihypertensive === '是';
        }
        if (this.antipsychotic) {
          requestData.atypicalAntipsychotics = this.antipsychotic === '是';
        }
        if (this.steroid) {
          requestData.oralCorticosteroids = this.steroid === '是';
        }
        if (this.erectileDysfunction && this.avatar === 1) {
          requestData.erectileDysfunction = this.erectileDysfunction === '是';
        }
        if (this.depressionLevel) {
          requestData.depressionEval = this.getDepressionValue(); 
        }
      } else if (step === 3) {
        // 第三步：生活习惯信息
        requestData.takeMed = this.drug; // 默认不服用药物
        if (this.sleepDuration) {
          requestData.sleepQuality = this.getSleepHoursValue();
        }
        if (this.smokingStatus) {
          requestData.smokingStatus = this.getSmokingStatusValue();
        }
      }

      console.log(`保存第${step}步健康信息请求参数:`, requestData);
      
      v2uphealthinfo(requestData).then((res) => {
        console.log(`保存第${step}步健康信息响应:`, res);
        if (res.code === '1000') {
          console.log(`第${step}步健康信息保存成功`);
        } else {
          console.error(`第${step}步健康信息保存失败:`, res.msg);
        }
      }).catch((error) => {
        console.error(`第${step}步健康信息保存异常:`, error);
      });
    },

    /**
     * 获取已选择的个人疾病列表
     */
    getSelectedDiseases() {
      return this.diseaseList
        .filter(item => item.selected)
        .map(item => ({
          id: item.keyId,
          tagCode: item.tagCode || `DISEASE_${item.keyId}`,
          tagName: item.tagName
        }));
    },

    /**
     * 获取已选择的家族疾病列表
     */
    getSelectedFamilyDiseases() {
      return this.familyDiseaseList
        .filter(item => item.familySelected)
        .map(item => ({
          id: item.keyId,
          tagCode: item.tagCode || `FAMILY_${item.keyId}`,
          tagName: item.tagName
        }));
    },

    /**
     * 获取已选择的精神类疾病列表
     */
    getSelectedMentalDiseases() {
      return this.mentalHealthDiseaseList
        .filter(item => this.mentalHealthConditions.includes(item.tagName) && item.tagName !== '以上均没有')
        .map(item => ({
          id: item.id,
          tagCode: item.tagCode || `MENTAL_${item.id}`,
          tagName: item.tagName
        }));
    },

    /**
     * 获取睡眠状态值
     */
    getSleepStatusValue() {
      // 根据接口文档，这里应该返回枚举值，暂时返回空字符串
      return '';
    },

    /**
     * 获取抑郁评估值
     */
    getDepressionValue() {
      // 直接返回 value，不进行映射
      return this.depressionLevel || '1';
    },

    /**
     * 获取睡眠质量值
     */
    getSleepQualityValue() {
      // 根据接口文档，这里应该返回枚举值，暂时返回空字符串
      return '';
    },

    /**
     * 获取吸烟状态值
     */
    getSmokingStatusValue() {
      // 直接返回value值：'1', '2', '3', '4', '5'
      return this.smokingStatus || '1';
    },

    /**
     * 获取睡眠时长值
     */
    getSleepHoursValue() {
      // 直接返回value值：'1', '2', '3', '4'
      return this.sleepDuration || '';
    },

     selectedClick(index) {
       console.log(index)
       this.diseaseList[index].selected = !this.diseaseList[index].selected
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择个人疾病（新方法，支持过滤后的列表）
      */
      selectedDiseaseClick(item) {
        console.log('选择疾病:', item.tagName)
        item.selected = !item.selected
        // 更新个人疾病数量
        this.updatePersonalDiseaseCount();
        // 保存数据
        this.saveUserData();
      },

     /**
      * 选择家族疾病（新方法，支持新的数据结构）
      */
     selectedFamilyDiseaseClick(item) {
       console.log('家族疾病选择:', item.tagName)
       console.log('选择前状态:', item.familySelected)
       item.familySelected = !item.familySelected
       console.log('选择后状态:', item.familySelected)
       // 更新家族疾病数量
       this.updateFamilyDiseaseCount();
       // 保存数据
       this.saveUserData();
     },

     /**
      * 更新家族疾病数量
      */
     updateFamilyDiseaseCount() {
       this.familyDiseaseCount = this.familyDiseaseList.filter(item => item.familySelected).length;
     },

     /**
      * 获取已选择的个人疾病数量
      */
     getSelectedDiseaseCount() {
       return this.diseaseList.filter(item => item.selected).length;
     },

     /**
      * 更新个人疾病数量
      */
     updatePersonalDiseaseCount() {
       this.personalDiseaseCount = this.diseaseList.filter(item => item.selected).length;
     },

     /**
      * 初始化家族疾病列表
      */
     initFamilyDiseaseList() {
       const familyDiseaseData = [
         { keyId: 101, tagName: "高血压家族史", selected: false, familySelected: false },
         { keyId: 102, tagName: "心肌梗死家族史", selected: false, familySelected: false },
         { keyId: 103, tagName: "脑卒中家族史", selected: false, familySelected: false },
         { keyId: 104, tagName: "糖尿病家族史", selected: false, familySelected: false },
         { keyId: 105, tagName: "哮喘家族史", selected: false, familySelected: false },
         { keyId: 106, tagName: "肥胖症家族史", selected: false, familySelected: false },
         { keyId: 107, tagName: "冠心病家族史", selected: false, familySelected: false },
         { keyId: 108, tagName: "恶性肿瘤家族史", selected: false, familySelected: false }
       ];
       this.familyDiseaseList = familyDiseaseData;
       console.log('家族疾病史列表已重新初始化:', this.familyDiseaseList);
     },

      /**
       * 显示疾病选择弹框
       */
      showDiseaseSelection(type) {
        this.currentDiseaseType = type;
        
        // 初始化临时数据（深拷贝当前数据）
        if (type === 'family') {
          this.tempFamilyDiseaseList = JSON.parse(JSON.stringify(this.familyDiseaseList));
        } else {
          this.tempDiseaseList = JSON.parse(JSON.stringify(this.diseaseList));
        }
        
        this.showDiseaseModal = true;
      },
      
      /**
       * 关闭疾病选择弹框
       */
      closeDiseaseModal() {
        // 清空临时数据
        this.tempFamilyDiseaseList = [];
        this.tempDiseaseList = [];
        this.showDiseaseModal = false;
      },
      
      /**
       * 切换疾病选择状态（操作临时数据）
       */
      toggleDisease(disease) {
        if (this.currentDiseaseType === 'family') {
          disease.familySelected = !disease.familySelected;
        } else {
          disease.selected = !disease.selected;
        }
      },
      
      /**
       * 确认疾病选择
       */
      confirmDiseaseSelection() {
        try {
          // 将临时数据复制到正式数据
          if (this.currentDiseaseType === 'family') {
            this.familyDiseaseList = JSON.parse(JSON.stringify(this.tempFamilyDiseaseList));
            // 更新家族疾病数量
            this.familyDiseaseCount = this.familyDiseaseList.filter(item => item.familySelected).length;
          } else {
            this.diseaseList = JSON.parse(JSON.stringify(this.tempDiseaseList));
            // 更新个人疾病数量
            this.personalDiseaseCount = this.diseaseList.filter(item => item.selected).length;
          }
          
          // 保存数据
          this.saveUserData();
          
          // 关闭弹窗
          this.closeDiseaseModal();
          
          // 显示成功提示
          this.$message && this.$message.success('疾病选择已保存');
        } catch (error) {
          console.error('保存疾病选择失败:', error);
          this.$message && this.$message.error('保存失败，请重试');
        }
      },
    skip() {
     
      if(this.active == 0) {
        console.log(this.active)
        this.active = 1;
        this.step1 = false;
        this.step2 = true;
      }else if(this.active == 1) {
        console.log(this.active)
        this.active = 2;
        this.step2 = false;
        this.step3 = true; 
      }else if(this.active == 2) {
        // this.modeShow = true 
        // this.modeOnConfirm() // 老年版模式选择（已注释，暂时禁用）
        // 直接跳转到普通版首页
        this.$router.push({
              path: "/healthHomePage",
              query:{
              }
            })
      }
    },
    /**
     * 下一步操作及必填项验证
     * @param {Number} type - 步骤类型（1:第一步, 2:第二步, 3:第三步, 21:兼容旧版第二步）
     */
    edit(type) {
       if(type == 1) {
        // 第一步必填项验证
        if(this.avatar === '' || this.avatar === null || this.avatar === undefined) {
          this.$message.error('请选择性别');
          return;
        }
        if(this.birthday === '' || this.birthday === null || this.birthday === undefined) {
          this.$message.error('请选择出生日期');
          return;
        }
        if(this.height === '' || this.height === null || this.height === undefined) {
          this.$message.error('请选择身高');
          return;
        }
        if(this.weight === '' || this.weight === null || this.weight === undefined) {
          this.$message.error('请选择体重');
          return;
        }
        if(this.waist === '' || this.waist === null || this.waist === undefined) {
          this.$message.error('请选择腰围');
          return;
        }
        if(this.ethnicity === '' || this.ethnicity === null || this.ethnicity === undefined) {
          this.$message.error('请选择民族');
          return;
        }
        if(this.location === '' || this.location === null || this.location === undefined) {
          this.$message.error('请选择常住地');
          return;
        }
        if(this.industry === '' || this.industry === null || this.industry === undefined) {
          this.$message.error('请选择所在行业');
          return;
        }
        
        this.active = 1;
        this.step1 = false;
        this.step2 = true;
        
        // 保存第一步数据
        this.v2uphealthinfoFun(1);
       }
       if(type == 2) {
        // 验证第二步必填项
        if(this.familyDisease === '' || this.familyDisease === null || this.familyDisease === undefined) {
          this.$message.error('请选择是否有家族疾病史');
          return;
        }
        if(this.disease === '' || this.disease === null || this.disease === undefined) {
          this.$message.error('请选择是否有个人疾病史');
          return;
        }
        
        // 验证药物相关问题（如果显示）
        if(this.showAntihypertensiveQuestion) {
          if(this.antihypertensive === '' || this.antihypertensive === null || this.antihypertensive === undefined) {
            this.$message.error('请选择是否服用降压药物');
            return;
          }
        }
        
        if(this.showAntipsychoticQuestion) {
          if(this.antipsychotic === '' || this.antipsychotic === null || this.antipsychotic === undefined) {
            this.$message.error('请选择是否服用非典型抗精神病药物');
            return;
          }
          if(this.steroid === '' || this.steroid === null || this.steroid === undefined) {
            this.$message.error('请选择是否服用常规类固醇片剂');
            return;
          }
          // 如果是男性，验证勃起功能障碍问题
          if(this.avatar === 1) {
            if(this.erectileDysfunction === '' || this.erectileDysfunction === null || this.erectileDysfunction === undefined) {
              this.$message.error('请选择是否患有勃起功能障碍');
              return;
            }
          }
        }
        
        if(this.depressionLevel === '' || this.depressionLevel === null || this.depressionLevel === undefined) {
          this.$message.error('请选择抑郁自评等级');
          return;
        }
        
        this.active = 2;
        this.step2 = false;   
        this.step3 = true;   
        
        // 保存第二步数据（疾病史、精神类疾病等）
        this.v2uphealthinfoFun(2);
       }
       if(type == 21) {
        this.active = 2;
        this.step2 = false;
        this.step3 = true; 
        
        // 保存个人疾病选择数据
        this.v2uphealthinfoFun(2);
       }
       if(type == 3) {
        // 验证第三步必填项
        if(this.sleepDuration === '' || this.sleepDuration === null || this.sleepDuration === undefined) {
          this.$message.error('请选择睡眠质量时长');
          return;
        }
        if(this.smokingStatus === '' || this.smokingStatus === null || this.smokingStatus === undefined) {
          this.$message.error('请选择吸烟状态');
          return;
        }
        
        // 保存第三步数据（睡眠、吸烟等）
        this.v2uphealthinfoFun(3);
         
         // 清除备份数据
         this.clearBackupData();
         
         // 直接跳转到普通版首页
         this.$router.push({
               path: "/healthHomePage",
               query:{
               }
             })
       }
       
    }, 
    /**
     * 老年版模式确认处理（已注释，暂时禁用）
     * 功能：根据用户选择的模式（普通版/老年版）进行相应处理
     * 逻辑：
     * 1. 将选择的模式存储到localStorage的oldAge字段
     * 2. 如果在App环境中，调用原生接口设置老年版状态
     * 3. 根据模式选择跳转到对应页面：
     *    - modeAct=0: 跳转到普通版首页(/health)
     *    - modeAct=1: 跳转到老年版首页(/oldAgeHealth)
     * 入口：信息收集完成后的模式选择确认
     */
    // modeOnConfirm() {
    //   localStorage.setItem('oldAge',this.modeAct)
    //   if (this.$env.inDjxApp){
    //         if (this.$env.inAndroid){
    //            try {
    //             JSInterface.setElderlyVersion(JSON.stringify({elderly:this.modeAct}))
    //           } catch (error) {
    //             console.log(error)
    //           }
    //         }else if (this.$env.inIos) {
    //           try {
    //             // window.webkit.messageHandlers.saveUserInfo.postMessage(JSON.stringify(res.data));
    //           } catch (error) {
    //             console.log(error)
    //           }
    //         }
    //       }
    //   if(this.modeAct==0) {
    //    
    //     this.$router.push({
    //           path: "/healthHomePage",
    //           query:{
    //           }
    //         })
    //   }else {
    //     this.$router.push({
    //           path: "/oldAgeHealth",
    //           query:{
    //           }
    //         })
    //   }
    // },
    cancel1() {
      this.showPicker1 = false;
    },
     onConfirm1(idType) {
       this.weight = idType.keyId;
       console.log(idType);
       this.showPicker1 = false;
       // 保存数据
       this.saveUserData();
     },
     // 身高选择器方法
     onConfirmHeight(idType) {
       this.height = idType.keyId;
       console.log(idType);
       this.showHeightPicker = false;
       // 保存数据
       this.saveUserData();
     },
    cancelHeight() {
      this.showHeightPicker = false;
    },
     // 腰围选择器方法
     onConfirmWaist(idType) {
       this.waist = idType.keyId;
       console.log(idType);
       this.showWaistPicker = false;
       // 保存数据
       this.saveUserData();
     },
    cancelWaist() {
      this.showWaistPicker = false;
    },
     // 民族选择器方法
     onConfirmEthnicity(idType) {
       this.ethnicity = idType.keyId;
       console.log(idType);
       this.showEthnicityPicker = false;
       // 保存数据
       this.saveUserData();
     },
    cancelEthnicity() {
      this.showEthnicityPicker = false;
    },
     // 行业选择器方法
     onConfirmIndustry(idType) {
       this.industry = idType.text;
       console.log(idType);
       this.showIndustryPicker = false;
       // 保存数据
       this.saveUserData();
     },
     cancelIndustry() {
       this.showIndustryPicker = false;
     },
     // 常住地选择器方法
     onConfirmLocation({ selectedOptions, value }) {
       console.log('级联选择器选择结果:', { selectedOptions, value });
       
       if (selectedOptions && selectedOptions.length >= 2) {
         const cityOption = selectedOptions[selectedOptions.length - 1];
         this.location = cityOption.keyId;
         // 更新级联选择器的值，使用选中的文本值
         this.locationCascaderValue = selectedOptions.map(option => option.text);
         console.log('选择的常住地:', cityOption);
         console.log('级联选择器值:', this.locationCascaderValue);
       }
       
       this.showLocationPicker = false;
       // 保存数据
       this.saveUserData();
     },
     cancelLocation() {
       this.showLocationPicker = false;
     },

     /**
      * 修复常住地数据结构，确保每个选项都有唯一的value值
      */
     fixLocationDataStructure() {
       this.locationColumns.forEach((province, provinceIndex) => {
         // 为省份添加唯一的value值
         if (!province.value) {
           province.value = `province_${provinceIndex}`;
         }
         
         // 为城市添加唯一的value值
         if (province.children) {
           province.children.forEach((city, cityIndex) => {
             if (!city.value) {
               city.value = `city_${provinceIndex}_${cityIndex}`;
             }
           });
         }
       });
     },


     /**
      * 根据location值设置级联选择器的值
      */
     setLocationCascaderValueFromLocation() {
       if (!this.location) return;
       
       // 遍历所有省份和城市，找到匹配的location
       for (const province of this.locationColumns) {
         for (const city of province.children) {
           if (city.keyId === this.location) {
             this.locationCascaderValue = [province.text, city.text];
             console.log('根据location设置级联选择器值:', this.locationCascaderValue);
             return;
           }
         }
       }
     },

     /**
      * 保存用户数据到localStorage
      */
     saveUserData() {
       const userData = {
         avatar: this.avatar,
         birthday: this.birthday,
         height: this.height,
         weight: this.weight,
         waist: this.waist,
         ethnicity: this.ethnicity,
         location: this.location,
         industry: this.industry,
         locationCascaderValue: this.locationCascaderValue,
         // 保存步骤状态
         step1: this.step1,
         step2: this.step2,
         step3: this.step3,
         active: this.active,
         // 保存疾病相关数据
         disease: this.disease,
         drug: this.drug,
         quality: this.quality,
         step2If: this.step2If,
         diseaseList: this.diseaseList,
         // 保存新增字段
         familyDisease: this.familyDisease,
         familyDiseaseCount: this.familyDiseaseCount,
         familyDiseaseList: this.familyDiseaseList,
         personalDiseaseCount: this.personalDiseaseCount,
         antihypertensive: this.antihypertensive,
         antipsychotic: this.antipsychotic,
         steroid: this.steroid,
         depressionLevel: this.depressionLevel,
         // 保存睡眠质量和吸烟相关数据
         sleepDuration: this.sleepDuration,
         smokingStatus: this.smokingStatus,
         // 保存精神类疾病相关数据
         mentalHealthConditions: this.mentalHealthConditions,
         mentalHealthDiseaseList: this.mentalHealthDiseaseList,
         erectileDysfunction: this.erectileDysfunction,
      // 保存家族疾病史列表
      familyDiseaseList: this.familyDiseaseList
       };
       
       localStorage.setItem('informationGathering_backup', JSON.stringify(userData));
     },

     /**
      * 从localStorage恢复用户数据
      */
     restoreUserData() {
       const savedData = localStorage.getItem('informationGathering_backup');
       if (savedData) {
         try {
           const userData = JSON.parse(savedData);
           
           // 恢复基本信息
           // 如果接口没有返回性别，才从localStorage恢复
           if (!this.hasHealthInfoFromApi) {
           this.avatar = userData.avatar || 1;
           this.birthday = userData.birthday || '';
           }
           this.height = userData.height || '';
           this.weight = userData.weight || '';
           this.waist = userData.waist || '';
           this.ethnicity = userData.ethnicity || '';
           this.location = userData.location || '';
           this.industry = userData.industry || '';
           
          // 恢复常住地级联选择器的值
          this.locationCascaderValue = userData.locationCascaderValue || [];
          
          // 如果没有级联选择器的值但有location值，需要根据location设置级联选择器的值
          if (this.location && this.locationCascaderValue.length === 0) {
            this.setLocationCascaderValueFromLocation();
          }
           
           // 恢复步骤状态
           this.step1 = userData.step1 !== undefined ? userData.step1 : true;
           this.step2 = userData.step2 || false;
           this.step3 = userData.step3 || false;
           this.active = userData.active || 0;
           
           // 恢复疾病相关数据
           this.disease = userData.disease || false;
           this.drug = userData.drug || false;
           this.quality = userData.quality || 0;
           this.step2If = userData.step2If !== undefined ? userData.step2If : true;
           
           // 恢复新增字段
           this.familyDisease = userData.familyDisease || false;
           this.familyDiseaseCount = userData.familyDiseaseCount || 0;
           this.familyDiseaseList = userData.familyDiseaseList || [];
           this.personalDiseaseCount = userData.personalDiseaseCount || 0;
           this.antihypertensive = userData.antihypertensive || '';
           this.antipsychotic = userData.antipsychotic || '';
           this.steroid = userData.steroid || '';
           this.depressionLevel = userData.depressionLevel || '';
           // 恢复睡眠质量和吸烟相关数据
           this.sleepDuration = userData.sleepDuration || '';
           this.smokingStatus = userData.smokingStatus || '';
           // 恢复精神类疾病相关数据
           this.mentalHealthConditions = userData.mentalHealthConditions || ['以上均没有'];
           this.mentalHealthDiseaseList = userData.mentalHealthDiseaseList || [];
           this.erectileDysfunction = userData.erectileDysfunction || '';
           // 恢复家族疾病史列表
           if (userData.familyDiseaseList && userData.familyDiseaseList.length > 0) {
             this.familyDiseaseList = userData.familyDiseaseList;
           }
           
           // 恢复疾病列表（需要与API数据合并）
           if (userData.diseaseList && userData.diseaseList.length > 0) {
             // 延迟恢复疾病列表，等待API数据加载完成
             this.$nextTick(() => {
               this.mergeDiseaseList(userData.diseaseList);
               // 恢复个人疾病数量
               this.updatePersonalDiseaseCount();
             });
           }
           
         } catch (e) {
           console.error('恢复用户数据失败:', e);
         }
       }
     },

     /**
      * 合并疾病列表数据
      */
     mergeDiseaseList(savedDiseaseList) {
       if (this.diseaseList && this.diseaseList.length > 0) {
         // 根据keyId匹配并恢复选中状态
         savedDiseaseList.forEach(savedItem => {
           const currentItem = this.diseaseList.find(item => item.keyId === savedItem.keyId);
           if (currentItem) {
             currentItem.selected = savedItem.selected;
             // 恢复家族疾病选择状态
             if (savedItem.familySelected !== undefined) {
               currentItem.familySelected = savedItem.familySelected;
             }
           }
         });
         // 更新家族疾病数量
         this.updateFamilyDiseaseCount();
       }
     },

     /**
      * 清除备份数据
      */
     clearBackupData() {
       localStorage.removeItem('informationGathering_backup');
     },

     /**
      * 选择性别
      */
     selectGender(gender) {
       this.avatar = gender;
       
       // 如果选择女性，清空勃起功能障碍的选择
       if (gender === 2) {
         this.erectileDysfunction = '';
       }
       
       // 重新获取疾病数据（因为性别会影响疾病显示）
       this.loadDiseaseData();
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择疾病史
      */
     selectDisease(hasDisease) {
      this.disease = hasDisease;
      if (hasDisease) {
        // 选择"是"时，直接进行下一步，不弹出选择框
        this.step2If = true;
      } else {
         // 选择"否"时，清空个人疾病列表和相关药物选择
         this.diseaseList.forEach(item => {
           item.selected = false;
         });
         // 清空相关药物选择
         this.antihypertensive = '';
         this.antipsychotic = '';
         this.steroid = '';
         // 更新个人疾病数量
         this.updatePersonalDiseaseCount();
       }
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择药物
      */
     selectDrug(takeDrug) {
       this.drug = takeDrug;
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择睡眠质量
      */
     selectQuality(qualityLevel) {
       this.quality = qualityLevel;
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择家族疾病史
      */
     selectFamilyDisease(hasFamilyDisease) {
      this.familyDisease = hasFamilyDisease;
      if (hasFamilyDisease) {
        // 选择"是"时，直接进行下一步，不弹出选择框
        if (this.familyDiseaseList.length === 0) {
          this.initFamilyDiseaseList();
        }
        this.step2If = true;
      } else {
         // 选择"否"时，清空家族疾病列表
         this.familyDiseaseList = [];
         this.familyDiseaseCount = 0;
       }
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择抑郁程度
      */
     selectDepression(level) {
       this.depressionLevel = level;
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择睡眠时长
      */
     selectSleepDuration(duration) {
       this.sleepDuration = duration;
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择吸烟状态
      */
     selectSmokingStatus(status) {
       this.smokingStatus = status;
       // 保存数据
       this.saveUserData();
     },

     /**
      * 选择精神类疾病
      */
     selectMentalHealthCondition(condition) {
       if (condition === '以上均没有') {
         // 如果选择"以上均没有"，清空其他所有选择
         this.mentalHealthConditions = ['以上均没有'];
       } else {
         // 如果选择其他疾病，先移除"以上均没有"，再处理当前选择
         this.mentalHealthConditions = this.mentalHealthConditions.filter(item => item !== '以上均没有');
         
         const index = this.mentalHealthConditions.indexOf(condition);
         if (index > -1) {
           // 如果已选择，则取消选择
           this.mentalHealthConditions.splice(index, 1);
         } else {
           // 如果未选择，则添加选择
           this.mentalHealthConditions.push(condition);
         }
         
         // 如果没有任何选择，自动选择"以上均没有"
         if (this.mentalHealthConditions.length === 0) {
           this.mentalHealthConditions = ['以上均没有'];
         }
       }
       // 保存数据
       this.saveUserData();
     },

     // 降压药物选择器方法
     onConfirmAntihypertensive(idType) {
       this.antihypertensive = idType.keyId;
       this.showAntihypertensivePicker = false;
       // 保存数据
       this.saveUserData();
     },
     cancelAntihypertensive() {
       this.showAntihypertensivePicker = false;
     },

     // 抗精神病类药物选择器方法
     onConfirmAntipsychotic(idType) {
       this.antipsychotic = idType.keyId;
       this.showAntipsychoticPicker = false;
       // 保存数据
       this.saveUserData();
     },
     cancelAntipsychotic() {
       this.showAntipsychoticPicker = false;
     },

     // 类固醇片剂选择器方法
     onConfirmSteroid(idType) {
       this.steroid = idType.keyId;
       this.showSteroidPicker = false;
       // 保存数据
       this.saveUserData();
     },
     cancelSteroid() {
       this.showSteroidPicker = false;
     },

     // 勃起功能障碍选择器方法
     onConfirmErectileDysfunction(idType) {
       this.erectileDysfunction = idType.keyId;
       this.showErectileDysfunctionPicker = false;
       // 保存数据
       this.saveUserData();
     },
     cancelErectileDysfunction() {
       this.showErectileDysfunctionPicker = false;
     },


     /**
      * 根据location值设置级联选择器的值
      */
     setLocationCascaderValueFromLocation() {
       if (!this.location) return;
       
       // 遍历所有省份和城市，找到匹配的location
       for (const province of this.locationColumns) {
         for (const city of province.children) {
           if (city.keyId === this.location) {
             this.locationCascaderValue = [province.text, city.text];
             console.log('根据location设置级联选择器值:', this.locationCascaderValue);
             return;
           }
         }
       }
     },

    /**
     * 获取常住地显示文本
     */
    getLocationDisplayText() {
      if (!this.location) return '';
      
      // 如果locationCascaderValue有值，使用它来显示
      if (this.locationCascaderValue && this.locationCascaderValue.length > 0) {
        return this.locationCascaderValue.join('');
      }
      
      // 否则根据location查找对应的显示文本
      for (const province of this.locationColumns) {
        for (const city of province.children) {
          if (city.keyId === this.location) {
            return `${province.text}${city.text}`;
          }
        }
      }
      
      return this.location;
     },

    childShow(msg) {
      this.value = msg;
    },
     parentMethod(msg) {
       // 将中文格式的日期转换为 yyyy-MM-dd 格式
       this.birthday = this.formatDate(new Date(this.transferTime(msg)));
       console.log('选择的生日:', msg, '转换后:', this.birthday);
       this.value = false;
       // 保存数据
       this.saveUserData();
     },
    formatDate(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月份是从0开始的
      var day = date.getDate().toString().padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    transferTime(data) {
      let str = data;
      let regex = /年/g; // 使用正则表达式并设置全局标志g
      let regex1 = /月/g; // 使用正则表达式并设置全局标志g
      var newStr = str.replace(regex, "/"); // 替换所有的"World"为"Earth"
      var newStr2 = newStr.replace(regex1, "/"); // 替换所有的"World"为"Earth"
      return newStr2.slice(0, -1);
    },
    timeClick() {
      this.value = true;
    },
  }
};
</script>
<style scoped>
/* 全局样式重置和基础设置 */
* {
  box-sizing: border-box;
}

/* 外层滚动容器 */
.scroll-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #F2F3F5;
  z-index: 1;
}


/* 页面容器 - 修复滚动问题 */
.page-container {
  height: 100vh;
  background: #F2F3F5;
  padding-bottom: 40px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 页面背景渐变 */
body {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  min-height: 100vh;
}

/* 主容器样式 */
.container {
  background: linear-gradient(135deg, #f0f9f5 0%, #e8f5e8 100%);
  min-height: 100vh;
  padding-bottom: 20px;
}

/* 标题样式 */
.title {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  text-align: center;
  padding: 20px 15px;
  position: relative;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 194, 117, 0.3);
  margin-bottom: 0;
}

.subtitle {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  text-align: center;
  padding: 20px 15px 20px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  margin-bottom: 0;
}

/* 步骤指示器样式优化 */
.van-steps {
  background: #fff;
  margin: 0 15px;
  border-radius: 12px;
  padding: 12px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 性别选择样式 */
.gender-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 30px 20px;
  background: #fff;
  margin: 15px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.gender-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 20px;
  border: 2px solid #e8ecf3;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 80px;
  background: #fff;
  position: relative;
  overflow: hidden;
}

.gender-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 194, 117, 0.1), transparent);
  transition: left 0.6s;
}

.gender-item:hover::before {
  left: 100%;
}

.gender-item:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 194, 117, 0.2);
}

.gender-selected {
  border-color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 194, 117, 0.3);
}

.gender-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 8px;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.gender-selected .gender-icon {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 194, 117, 0.3);
}

.male-icon {
  background: transparent;
}

.female-icon {
  background: transparent;
}

.gender-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.gender-text {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  transition: color 0.3s ease;
}

.gender-selected .gender-text {
  color: #fff;
}

/* 表单容器样式 */
.form-container {
  background: #fff;
  margin: 15px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.form-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f2f5;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.form-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.form-item:hover::before {
  transform: scaleY(1);
}

.form-item:hover {
  background: linear-gradient(90deg, rgba(0, 194, 117, 0.05) 0%, transparent 100%);
  padding-left: 30px;
}

.form-item:last-child {
  border-bottom: none;
}

.form-label {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
  transition: color 0.3s ease;
}

.form-item:hover .form-label {
  color: #00C275;
}

.form-value {
  font-size: 14px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.form-value.placeholder {
  color: #95a5a6;
}

.form-value i {
  color: #bdc3c7;
  font-size: 14px;
  transition: color 0.3s ease;
}

.form-item:hover .form-value i {
  color: #00C275;
}

/* 所在行业特殊样式 */
.industry-item .form-label {
  margin-right: 20px;
  min-width: 80px;
  /* text-align: right; */
}

.industry-item .form-value {
  flex: 1;
  min-width: 0;
}

.industry-item .form-value span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  text-align: right;
}

.industry-item .form-value.placeholder {
  justify-content: flex-end;
}

/* 疾病标签样式 */
.diseaseTab {
  width: 120px;
  height: 42px;
  display: inline-block;
  border: 2px solid #e8ecf3;
  text-align: center;
  line-height: 38px;
  border-radius: 10px;
  margin: 6px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  font-weight: 500;
  font-size: 13px;
  color: #2c3e50;
  position: relative;
  overflow: hidden;
}

.diseaseTab::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 194, 117, 0.1), transparent);
  transition: left 0.6s;
}

.diseaseTab:hover::before {
  left: 100%;
}

.diseaseTab:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.2);
}

.diseaseTabAct {
  border: 2px solid #00C275 !important;
  color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.3);
}

/* 慢性肾病选项小字体样式 */
.diseaseTab-small {
  font-size: 11px !important;
  line-height: 36px !important;
}

.diseaseTab-small.diseaseTabAct {
  font-size: 11px !important;
  line-height: 36px !important;
}

/* 主要按钮样式 */
.add1 {
  width: 85%;
  margin: 20px auto 0;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  border: none;
  padding: 10px 0;
  border-radius: 25px;
  color: #fff;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  box-shadow: 0 4px 15px rgba(0, 194, 117, 0.25);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.add1::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s;
}

.add1:hover::before {
  left: 100%;
}

.add1:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 194, 117, 0.4);
}

.add1:active {
  transform: translateY(0);
  box-shadow: 0 4px 15px rgba(0, 194, 117, 0.3);
}

/* 跳过按钮样式 */
.skip {
  position: absolute;
  top: 20px;
  right: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 8px 16px;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.skip:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
}

/* 步骤指示器样式 */
.van-steps--horizontal {
  padding: 1px 20px !important;
  background: #fff;
  border-radius: 12px;
  margin: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 旧版样式兼容 */
.avatarCla {
  border: 3px solid #00C275 !important;
  color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
}

.step3DivAct {
  border: 2px solid #00C275 !important;
  color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
}
/* 列表项样式 */
.li {
  width: 100%;
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #f0f2f5;
  line-height: 60px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.li:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.name {
  color: #2c3e50;
  font-weight: 600;
  font-size: 16px;
}

.value {
  font-weight: 500;
  font-size: 16px;
  color: #00C275;
  float: right;
}

.li div {
  display: inline-block;
}

/* 步骤标题样式 */
.step2Title {
  font-size: 28px;
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #fff;
  margin: 15px;
  border-radius: 16px;
  font-weight: 700;
  box-shadow: 0 4px 15px rgba(0, 194, 117, 0.3);
}

.step3Title {
  font-size: 22px;
  text-align: center;
  padding: 20px;
  background: #fff;
  margin: 15px;
  border-radius: 12px;
  color: #2c3e50;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 步骤3选择按钮样式 */
.step3Div {
  width: 40%;
  height: 55px;
  text-align: center;
  border: 2px solid #e8ecf3;
  line-height: 51px;
  margin: 0 auto;
  margin-top: 25px;
  font-size: 18px;
  font-weight: 600;
  display: inline-block;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  color: #2c3e50;
  position: relative;
  overflow: hidden;
}

.step3Div::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 194, 117, 0.1), transparent);
  transition: left 0.6s;
}

.step3Div:hover::before {
  left: 100%;
}

.step3Div:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.2);
}

/* 疾病选择大按钮样式 */
.sdiseaseDiv {
  width: 85%;
  height: 85px;
  text-align: center;
  border: 3px solid #e8ecf3;
  line-height: 79px;
  margin: 0 auto;
  margin-top: 25px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  color: #2c3e50;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.sdiseaseDiv::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 194, 117, 0.1), transparent);
  transition: left 0.6s;
}

.sdiseaseDiv:hover::before {
  left: 100%;
}

.sdiseaseDiv:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 194, 117, 0.2);
}

/* 对话框样式 */
.promptName {
  padding: 15px 25px;
  font-size: 16px;
  line-height: 1.6;
  color: #2c3e50;
}

.prompt {
  font-size: 13px;
  color: #e74c3c;
  font-weight: 500;
  margin-top: 8px;
}

.van-dialog__content {
  padding: 25px 0;
  background: #fff;
  border-radius: 12px;
}

.modeDiv {
  padding: 25px;
  background: #fff;
  border-radius: 12px;
}

/* 疾病史部分样式 */
.disease-section {
  background: #fff;
  margin: 15px;
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
}

.disease-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
}

.disease-title {
  font-size: 15px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  text-align: center;
  position: relative;
}

.disease-title::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-radius: 1px;
}

.disease-options {
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 10px 0;
}

.disease-option {
  position: relative;
  width: 75px;
  height: 30px;
  border: 2px solid #e8ecf3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  overflow: visible;
  margin: 5px;
}

/* 移除虚影效果 */

.disease-option:hover {
  border-color: #00C275;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 194, 117, 0.2);
}

.disease-selected {
  border-color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 194, 117, 0.3);
}

.disease-text {
  font-size: 14px;
  font-weight: 600;
  transition: color 0.3s ease;
}

.disease-count {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 18px;
  height: 18px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(255, 107, 107, 0.3);
  border: 1.5px solid #fff;
  animation: pulse 2s infinite;
  z-index: 10;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 药物部分样式 */
.medication-section {
  background: #fff;
  margin: 15px;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.medication-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
}

.medication-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f0f2f5;
  transition: all 0.3s ease;
  position: relative;
}

.medication-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.medication-item:hover::before {
  transform: scaleY(1);
}

.medication-item:hover {
  background: linear-gradient(90deg, rgba(0, 194, 117, 0.05) 0%, transparent 100%);
  padding-left: 15px;
}

.medication-item:last-child {
  border-bottom: none;
}

.medication-question {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: color 0.3s ease;
}

.medication-item:hover .medication-question {
  color: #00C275;
}

.help-icon {
  width: 22px;
  height: 22px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
  cursor: help;
  transition: all 0.3s ease;
}

.help-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.4);
}

.medication-select {
  color: #00C275;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 15px;
  border: 2px solid #00C275;
  border-radius: 8px;
  min-width: 80px;
  text-align: center;
  transition: all 0.3s ease;
  background: #fff;
  position: relative;
  overflow: hidden;
}

.medication-select::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 194, 117, 0.1), transparent);
  transition: left 0.6s;
}

.medication-select:hover::before {
  left: 100%;
}

.medication-select:hover {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 194, 117, 0.3);
}

.medication-select .placeholder {
  color: #95a5a6;
  font-weight: 500;
}

/* 抑郁自评部分样式 */
.depression-section {
  background: #fff;
  margin: 15px;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.depression-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
}

.depression-title {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 25px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: relative;
}

.depression-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-radius: 2px;
}

.depression-count {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #2c3e50;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
  border: 2px solid #fff;
}

.depression-options {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.depression-option {
  width: 100%;
  height: 30px;
  border: 2px solid #e8ecf3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  position: relative;
  overflow: hidden;
}

/* 移除抑郁自评选项虚影效果 */

.depression-option:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.2);
}

.depression-selected {
  border-color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.3);
}

.depression-text {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  transition: color 0.3s ease;
}


/* 睡眠质量部分样式 */
.sleep-section {
  background: #fff;
  margin: 15px;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.sleep-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
}

.question-title {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 25px;
  text-align: center;
  position: relative;
}

.question-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-radius: 2px;
}

.sleep-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.sleep-option {
  height: 30px;
  border: 2px solid #e8ecf3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  position: relative;
  overflow: hidden;
}

/* 移除睡眠选项虚影效果 */

.sleep-option:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.2);
}

.sleep-selected {
  border-color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.3);
}

.sleep-text {
  font-size: 14px;
  font-weight: 600;
  transition: color 0.3s ease;
}

/* 吸烟部分样式 */
.smoking-section {
  background: #fff;
  margin: 15px;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.smoking-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
}

.smoking-options {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.smoking-option {
  height: 30px;
  border: 2px solid #e8ecf3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  position: relative;
  overflow: hidden;
}

.smoking-option:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.2);
}

.smoking-selected {
  border-color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.3);
}

.smoking-text {
  font-size: 13px;
  font-weight: 600;
  transition: color 0.3s ease;
  text-align: center;
  padding: 0 8px;
}

/* 精神类疾病部分样式 */
.mental-health-section {
  background: #fff;
  margin: 15px;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.mental-health-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
}

.mental-health-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.mental-health-option {
  height: 30px;
  border: 2px solid #e8ecf3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  position: relative;
  overflow: hidden;
}

/* 移除精神类疾病选项虚影效果 */

.mental-health-option:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.2);
}

.mental-health-selected {
  border-color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.3);
}

.mental-health-text {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  transition: color 0.3s ease;
}


/* 响应式设计：中等屏幕优化 */
@media (max-width: 768px) {
  .gender-selection {
    gap: 20px;
    padding: 25px 15px;
  }
  
  .gender-item {
    padding: 20px 25px;
    min-width: 90px;
  }
  
  .disease-options {
    gap: 20px;
  }
  
 
  
  .sleep-options {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .mental-health-options {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .smoking-options {
    gap: 15px;
  }
  
  .smoking-option {
    height: 30px;
  }
}

/* 疾病选择卡片样式 */
.disease-card {
  margin-top: 12px;
  background: #ffffff;
  border: 1px solid #E5E5E5;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    border-color: #00C275;
    box-shadow: 0 4px 12px rgba(0, 194, 117, 0.15);
  }
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #F5F5F5;
  background: #FAFAFA;
  
  span {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 16px;
    color: #00C275;
    font-weight: 500;
    transition: all 0.3s ease;
  }
  
  &:hover i {
    color: #4ECDC4;
    transform: scale(1.1);
  }
}

.disease-tags {
  padding: 16px 20px;
}

.tag-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tag-row {
  display: flex;
  gap: 8px;
}

.disease-tag {
  flex: 1;
  padding: 8px 12px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border: 1px solid #00C275;
  border-radius: 16px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  transition: all 0.3s ease;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.2);
}

.disease-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.3);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  
  .empty-text {
    font-size: 14px;
    color: #999;
    margin-bottom: 6px;
  }
  
  .add-text {
    font-size: 12px;
    color: #00C275;
    font-weight: 500;
  }
}

/* 疾病选择弹框样式 */
.disease-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  /* 确保弹框在可视区域中间 */
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  /* 防止页面滚动影响弹框位置 */
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
}

.disease-modal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
  /* 确保弹框内容居中 */
  align-self: center;
  justify-self: center;
  margin: 0 auto;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f2f5;
  position: relative;
}

.modal-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  border-radius: 16px 16px 0 0;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.modal-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: #e9ecef;
  transform: scale(1.1);
}

.modal-close i {
  font-size: 16px;
  color: #6c757d;
}

.modal-content {
  flex: 1;
  padding: 20px 24px;
  overflow-y: auto;
  max-height: 400px;
}

.disease-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.disease-item {
  padding: 12px 16px;
  border: 2px solid #e8ecf3;
  border-radius: 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  position: relative;
  overflow: hidden;
}

.disease-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 194, 117, 0.1), transparent);
  transition: left 0.6s;
}

.disease-item:hover::before {
  left: 100%;
}

.disease-item:hover {
  border-color: #00C275;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.2);
}

.disease-selected {
  border-color: #00C275 !important;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.3);
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #f0f2f5;
}

.cancel-btn, .confirm-btn {
  flex: 1;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.cancel-btn {
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #e9ecef;
}

.cancel-btn:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.confirm-btn {
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.3);
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 194, 117, 0.4);
}

/* 响应式设计：大屏幕优化 */
@media (min-width: 1200px) {
  .form-container {
    max-width: 800px;
    margin: 15px auto;
  }
  
  .disease-section,
  .medication-section,
  .depression-section,
  .sleep-section,
  .smoking-section,
  .mental-health-section {
    max-width: 800px;
    margin: 15px auto;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/informationGathering/index.vue